var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscoverLandingBackgroundPatternWeb = function SvgDiscoverLandingBackgroundPatternWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1540,
    height: 846,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#Discover_Landing_Background_Pattern_Web_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 699.757a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 699.757a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 699.757a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.589ZM1442.23 699.757a2.552 2.552 0 0 0-3.59 0c-.98.976-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.97-2.613 0-3.589ZM1456.2 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 699.757a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 699.757a2.552 2.552 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 711.487a2.54 2.54 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.589.99.991 2.62.977 3.59 0 .98-.976.98-2.613 0-3.589ZM1386.33 746.721a2.54 2.54 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 711.487a2.54 2.54 0 0 0-3.59 0c-.98.991-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589ZM1456.2 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 711.487c-.99-.991-2.61-.991-3.58 0-.98.991-.99 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.98-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589ZM1498.11 711.487a2.54 2.54 0 0 0-3.59 0c-.98.991-.98 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589ZM1512.08 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.99 2.613 0 3.589s2.62.976 3.59 0c.99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 734.976c-.99-.991-2.61-.976-3.59 0a2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.976 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 746.721a2.54 2.54 0 0 0-3.59 0c-.97.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589ZM1498.11 746.721a2.54 2.54 0 0 0-3.59 0c-.98.99-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 758.451c-.99-.991-2.61-.976-3.59 0s-.98 2.613 0 3.589c.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589ZM1386.33 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1386.33 758.451c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.62.977 3.59 0 .98-.976.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 770.195a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1414.28 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 770.195a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 770.195a2.554 2.554 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1512.08 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 782.801a2.542 2.542 0 0 0-3.58 0c-.98.977-.98 2.614 0 3.59a2.54 2.54 0 0 0 3.58 0 2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.99 2.614 0 3.59s2.61.976 3.59 0c.99-.991.97-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 782.801a2.542 2.542 0 0 0-3.58 0c-.98.977-.98 2.614 0 3.59.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.2 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.99.991 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 782.801a2.554 2.554 0 0 0-3.59 0c-.98.977-.98 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1498.11 673.913c-.99-.991-2.61-.976-3.59 0s-.98 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.97-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.99 2.614 0 3.59s2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 794.532a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.98-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 794.532a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .98-.976.99-2.613 0-3.589ZM1456.2 794.532a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 794.532a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.98-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 794.532a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .97-.976.99-2.613 0-3.589ZM1442.23 590.854c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 590.854c-.99-.991-2.61-.976-3.59 0s-.98 2.613 0 3.589c.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 590.854c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.62.977 3.59 0 .98-.976.98-2.613 0-3.589ZM1386.33 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59.99.991 2.62.991 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 602.598a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.991 3.58 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.614 0 3.59s2.61.991 3.59 0c.99-.991.97-2.613 0-3.59ZM1484.15 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59a2.54 2.54 0 0 0 3.59-3.59ZM1498.11 602.598a2.554 2.554 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59 2.54 2.54 0 0 0 3.59 0c.99-.991.97-2.613 0-3.59ZM1512.08 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.614 0 3.59s2.62.991 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1386.33 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.62.977 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 614.343c-.99-.991-2.61-.976-3.59 0a2.54 2.54 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 614.343a2.54 2.54 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.97.991 2.61.977 3.58 0 .99-.99.99-2.613 0-3.589Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 614.343a2.553 2.553 0 0 0-3.59 0 2.54 2.54 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.61.977 3.59 0 .99-.99.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 614.343c-.99-.991-2.61-.976-3.59 0a2.549 2.549 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589ZM1512.08 614.343c-.99-.991-2.61-.976-3.59 0a2.54 2.54 0 0 0 0 3.589c.99.991 2.62.977 3.59 0 .99-.99.98-2.613 0-3.589ZM1386.33 626.088a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 552.749a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 564.493a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0 .98-.977.98-2.613 0-3.59ZM1386.33 576.223a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59.99.991 2.62.991 3.59 0 .98-.991.98-2.613 0-3.59ZM1400.3 626.088a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.99-.991.98-2.613 0-3.589ZM1414.28 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 626.088a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 626.088a2.552 2.552 0 0 0-3.59 0c-.98.976-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 626.088a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589a2.54 2.54 0 0 0 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 626.088a2.552 2.552 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.99 2.613 0 3.589s2.62.976 3.59 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 637.832a2.54 2.54 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.62.99 3.59 0 .98-.991.98-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 637.832c-.99-.991-2.61-.991-3.58 0-.98.991-.98 2.613 0 3.59.99.99 2.61.99 3.58 0 .98-.991.98-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.99 2.613 0 3.59.99.976 2.61.99 3.59 0 .97-.991.97-2.614 0-3.59Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 637.832c-.99-.991-2.61-.991-3.58 0-.98.991-.98 2.613 0 3.59.97.976 2.61.99 3.58 0 .98-.991.99-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 637.832a2.54 2.54 0 0 0-3.59 0c-.98.991-.99 2.613 0 3.59.99.976 2.61.99 3.59 0 .97-.991.97-2.614 0-3.59ZM1456.2 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.61.99 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 637.832c-.99-.991-2.61-.991-3.58 0-.98.991-.99 2.613 0 3.59.99.99 2.61.99 3.58 0 .98-.991.98-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.61.99 3.59 0 .97-.991.99-2.614 0-3.59ZM1386.33 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1400.3 649.562a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59ZM1414.28 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 649.562a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1386.33 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.62.991 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 661.307a2.54 2.54 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.99.991 2.61.991 3.58 0 .99-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.589.99.977 2.61.991 3.59 0 .99-.99.97-2.613 0-3.589ZM1428.25 661.307a2.54 2.54 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.97.977 2.61.991 3.58 0 .99-.99.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 673.913c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.62.991 3.59 0 .98-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 673.913a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.991 3.58 0 .98-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.61.991 3.59 0 .97-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 673.913a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.977 2.61.991 3.58 0 .98-.99.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 673.913c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.977 2.61.991 3.59 0 .97-.99.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.33 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1386.33 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 685.643a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 685.643a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0 .99-.991.99-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 737.345c-.99-.99-2.61-.99-3.58 0a2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.59ZM1414.28 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 723.232a2.54 2.54 0 0 0-3.58 0c-.99.99-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 685.643a2.553 2.553 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59ZM1442.23 580.66c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 518.936c-.99-.99-2.62-.99-3.59 0a2.541 2.541 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1442.23 530.681a2.553 2.553 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589ZM1442.23 542.426a2.54 2.54 0 0 0-3.59 0c-.98.99-.99 2.613 0 3.589s2.61.991 3.59 0c.97-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 554.17a2.553 2.553 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1442.23 508.742a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.99 3.59 0 .99-.991.97-2.613 0-3.59Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.2 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 685.643a2.54 2.54 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.59.99.99 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59ZM1484.15 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.97-.99.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 685.643c-.99-.991-2.61-.976-3.59 0a2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59ZM1498.11 661.307c-.99-.991-2.61-.976-3.59 0a2.549 2.549 0 0 0 0 3.589 2.54 2.54 0 0 0 3.59 0c.99-.99.97-2.613 0-3.589ZM1512.08 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.976 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1512.08 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.99 2.613 0 3.589s2.62.976 3.59 0c.99-.991.98-2.613 0-3.589ZM1512.08 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.62.991 3.59 0 .98-.99.98-2.613 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 699.757a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589s2.61.976 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 699.757c-.99-.991-2.6-.977-3.59 0-.99.976-.97 2.613 0 3.589.99.991 2.6.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589ZM1316.38 699.757a2.552 2.552 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 699.757a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.98-2.613 0-3.589Z",
    stroke: "#BFBFBF",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 699.757a2.552 2.552 0 0 0-3.59 0c-.98.976-.99 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 699.757a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589ZM1246.52 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .98-.976.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 711.487c-.99-.991-2.61-.991-3.58 0-.98.991-.99 2.613 0 3.589.99.977 2.61.977 3.58 0 .98-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 711.487a2.54 2.54 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.589.99.991 2.6.977 3.59 0 .99-.976.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.99.991 2.62.977 3.59 0 .98-.976.98-2.613 0-3.589ZM1316.38 711.487c-.99-.991-2.62-.991-3.59 0-.98.991-.98 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.98.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 711.487c-.99-.991-2.61-.991-3.58 0-.98.991-.98 2.613 0 3.589.97.977 2.61.977 3.58 0 .98-.976.98-2.613 0-3.589ZM1358.3 711.487a2.54 2.54 0 0 0-3.59 0c-.98.991-.99 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589ZM1372.27 711.487a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .98-.976.99-2.613 0-3.589ZM1246.52 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.98-2.613 0-3.589ZM1222.12 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.98 2.613 0 3.589s2.61.976 3.59 0c.99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.18 711.487a2.527 2.527 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.99.991 2.59.977 3.58 0 .99-.976.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.18 723.232c-.99-.991-2.59-.977-3.58 0-.99.99-.98 2.613 0 3.589.99.991 2.59.976 3.58 0 .99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 723.232a2.54 2.54 0 0 0-3.58 0c-.99.99-.99 2.613 0 3.589s2.61.976 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 723.232c-.99-.991-2.6-.977-3.59 0-.99.99-.97 2.613 0 3.589.99.991 2.6.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 723.232a2.54 2.54 0 0 0-3.58 0c-.99.99-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.99 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589ZM1372.27 723.232a2.552 2.552 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589ZM1246.52 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1260.49 734.976a2.54 2.54 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59ZM1274.47 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 734.976c-.99-.991-2.6-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.6.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 734.976a2.553 2.553 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 734.976a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59ZM1246.52 746.721a2.54 2.54 0 0 0-3.59 0c-.97.99-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 746.721c-.99-.991-2.61-.991-3.58 0-.98.99-.99 2.613 0 3.589s2.61.976 3.58 0c.99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 746.721a2.54 2.54 0 0 0-3.59 0c-.97.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 746.721a2.54 2.54 0 0 0-3.59 0c-.99.99-.97 2.613 0 3.589.99.991 2.6.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 746.721c-.99-.991-2.62-.991-3.59 0-.98.99-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 746.721a2.54 2.54 0 0 0-3.59 0c-.97.99-.97 2.613 0 3.589.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 746.721c-.99-.991-2.61-.991-3.58 0-.98.99-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.98-2.613 0-3.589ZM1246.52 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .98-.976.98-2.613 0-3.589ZM1260.49 758.451a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589.99.977 2.61.977 3.58 0 .98-.976.98-2.613 0-3.589ZM1274.47 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589ZM1316.38 758.451a2.553 2.553 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.98.977 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589ZM1344.32 758.451a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.977 2.61.977 3.58 0 .98-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 758.451c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589ZM1372.27 758.451c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .98-.976.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1234.18 758.451c-.99-.991-2.59-.976-3.58 0-.99.976-.98 2.613 0 3.589.99.991 2.59.977 3.58 0 .99-.976.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.18 770.195c-.99-.99-2.59-.976-3.58 0a2.55 2.55 0 0 0 0 3.59c.99.99 2.59.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 770.195a2.554 2.554 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1344.32 770.195a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1372.27 770.195a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 782.801a2.542 2.542 0 0 0-3.58 0c-.98.977-.99 2.614 0 3.59s2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 782.801a2.542 2.542 0 0 0-3.58 0c-.98.977-.98 2.614 0 3.59.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 782.801a2.554 2.554 0 0 0-3.59 0c-.98.977-.99 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1358.3 806.42c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59ZM1274.47 794.532a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589ZM1344.32 794.532a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .98-.976.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 794.532a2.552 2.552 0 0 0-3.59 0c-.98.976-.99 2.613 0 3.589.99.991 2.61.976 3.59 0 .97-.976.97-2.613 0-3.589ZM1372.27 794.532a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0s.99-2.613 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 590.854c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.61.977 3.59 0 .98-.976.98-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 590.854c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589ZM1302.4 590.854c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.62.977 3.59 0 .98-.976.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 590.854c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589c.99.991 2.61.977 3.59 0 .97-.976.97-2.613 0-3.589Z",
    fill: "#8A8A8A",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.614 0 3.59s2.61.991 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59a2.54 2.54 0 0 0 3.59 0c.99-.991.97-2.613 0-3.59ZM1302.4 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59.99.991 2.62.991 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1316.38 602.598a2.554 2.554 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59 2.54 2.54 0 0 0 3.59-3.59ZM1330.35 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59.98.976 2.61.991 3.59 0 .99-.991.97-2.613 0-3.59ZM1358.3 602.598a2.554 2.554 0 0 0-3.59 0 2.54 2.54 0 0 0 3.59 3.59c.99-.991.97-2.613 0-3.59ZM1246.52 614.343c-.99-.991-2.61-.976-3.59 0a2.54 2.54 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.18 614.343c-.99-.991-2.59-.976-3.58 0a2.549 2.549 0 0 0 0 3.589c.99.991 2.59.977 3.58 0 .99-.99.98-2.613 0-3.589ZM1274.47 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 614.343c-.99-.991-2.6-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.6.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.62.977 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 614.343a2.553 2.553 0 0 0-3.59 0 2.549 2.549 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.98.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589Z",
    fill: "#C4C4C4",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 614.343c-.99-.991-2.61-.976-3.59 0a2.54 2.54 0 0 0 0 3.589c.99.991 2.61.977 3.59 0 .99-.99.97-2.613 0-3.589ZM1246.52 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.99 2.613 0 3.589s2.61.976 3.59 0c.99-.991.98-2.613 0-3.589ZM1274.47 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 626.088c-.99-.991-2.6-.977-3.59 0-.99.976-.97 2.613 0 3.589.99.991 2.6.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.62.976 3.59 0 .99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 626.088a2.552 2.552 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 567.035a2.552 2.552 0 0 0-3.59 0c-.99.99-.98 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 578.779a2.553 2.553 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 578.779c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 590.509a2.554 2.554 0 0 0-3.59 0c-.98.977-.98 2.613 0 3.59.99.99 2.61.99 3.59 0 .97-.991.99-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 590.509a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.613 0 3.59.98.976 2.61.99 3.59 0 .97-.991.97-2.613 0-3.59Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 626.088a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 626.088a2.552 2.552 0 0 0-3.59 0c-.98.976-.99 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.97-2.613 0-3.589ZM1246.52 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.99 2.613 0 3.59.99.976 2.61.99 3.59 0 .98-.991.98-2.614 0-3.59ZM1222.12 637.832a2.54 2.54 0 0 0-3.59 0c-.98.991-.98 2.613 0 3.59.98.976 2.61.99 3.59 0 .97-.991.97-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 637.832c-.99-.991-2.61-.991-3.58 0-.98.991-.99 2.613 0 3.59.99.976 2.61.99 3.58 0 .98-.991.98-2.614 0-3.59ZM1234.18 637.832a2.527 2.527 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.59.99 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.61.99 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 637.832a2.54 2.54 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.6.99 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.62.99 3.59 0 .98-.991.98-2.614 0-3.59ZM1316.38 637.832c-.99-.991-2.62-.991-3.59 0-.98.991-.98 2.613 0 3.59.99.99 2.61.99 3.59 0 .97-.991.99-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.98.976 2.61.99 3.59 0 .97-.991.97-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 637.832c-.99-.991-2.61-.991-3.58 0-.98.991-.98 2.613 0 3.59.97.976 2.61.99 3.58 0 .98-.991.98-2.614 0-3.59ZM1358.3 637.832a2.54 2.54 0 0 0-3.59 0c-.98.991-.99 2.613 0 3.59.99.99 2.61.99 3.59 0 .97-.991.97-2.614 0-3.59ZM1372.27 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.61.99 3.59 0 .98-.991.99-2.614 0-3.59ZM1246.52 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1260.49 649.562a2.542 2.542 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59ZM1274.47 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 649.562c-.99-.99-2.6-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.6.976 3.59 0 .99-.991.97-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59ZM1316.38 649.562a2.554 2.554 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1344.32 649.562a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.99 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.613 0-3.59ZM1372.27 649.562a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59ZM1246.52 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.589.99.977 2.61.991 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 661.307a2.54 2.54 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.589.99.977 2.61.991 3.58 0 .99-.99.98-2.613 0-3.589ZM1234.18 661.307c-.99-.991-2.59-.976-3.58 0a2.549 2.549 0 0 0 0 3.589c.99.991 2.59.991 3.58 0 .99-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.99-.99.97-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 661.307c-.99-.991-2.6-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.6.991 3.59 0 .99-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.62.991 3.59 0 .99-.99.98-2.613 0-3.589Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 661.307a2.553 2.553 0 0 0-3.59 0 2.549 2.549 0 0 0 0 3.589 2.54 2.54 0 0 0 3.59-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.98.977 2.61.991 3.59 0 .99-.99.97-2.613 0-3.589ZM1344.32 661.307a2.54 2.54 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.97.977 2.61.991 3.58 0 .99-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 661.307c-.99-.991-2.61-.976-3.59 0a2.54 2.54 0 0 0 3.59 3.589c.99-.99.97-2.613 0-3.589ZM1372.27 661.307c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.99 2.613 0 3.589.99.977 2.61.991 3.59 0 .98-.99.98-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 673.913a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589.99.977 2.61.991 3.58 0 .98-.99.98-2.613 0-3.589ZM1260.49 543.387a2.542 2.542 0 0 0-3.58 0c-.99.991-.99 2.614 0 3.59s2.61.991 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 555.132a2.54 2.54 0 0 0-3.58 0 2.54 2.54 0 0 0 0 3.589 2.54 2.54 0 0 0 3.58 0c.99-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 566.877a2.54 2.54 0 0 0-3.58 0c-.98.976-.99 2.613 0 3.589s2.61.976 3.58 0c.99-.991.98-2.613 0-3.589ZM1260.49 579.468a2.542 2.542 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.99 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.99-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 673.913c-.99-.991-2.6-.976-3.59 0-.99.976-.97 2.613 0 3.589.99.991 2.6.991 3.59 0 .99-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.62.991 3.59 0 .98-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 673.913a2.553 2.553 0 0 0-3.59 0c-.98.976-.98 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.97-.99.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.98.977 2.61.991 3.59 0 .97-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 673.913a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.977 2.61.991 3.58 0 .98-.99.98-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 673.913c-.99-.991-2.61-.976-3.59 0s-.99 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.97-.99.97-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.98-.99.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 685.643a2.54 2.54 0 0 0-3.58 0c-.99.991-.99 2.613 0 3.59.99.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.43 685.643c-.99-.991-2.6-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.6.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.4 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.62.976 3.59 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 685.643a2.553 2.553 0 0 0-3.59 0 2.55 2.55 0 0 0 0 3.59c.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.14 685.643a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.12 685.643c-.99-.991-2.61-.976-3.59 0a2.55 2.55 0 0 0 0 3.59c.98.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.18 685.643c-.99-.991-2.59-.976-3.58 0a2.55 2.55 0 0 0 0 3.59c.99.99 2.59.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.98.976 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 685.643a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0a2.55 2.55 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.99 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.97-2.614 0-3.59ZM1372.27 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.17 746.721c-.99-.991-2.61-.991-3.58 0-.98.99-.98 2.613 0 3.589.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.17 758.451a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.977 2.61.977 3.58 0 .98-.976.99-2.613 0-3.589ZM1540.17 782.801a2.542 2.542 0 0 0-3.58 0c-.98.977-.98 2.614 0 3.59.97.976 2.61.976 3.58 0 .99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.17 590.854a2.54 2.54 0 0 0-3.58 0c-.98.976-.98 2.613 0 3.589.97.977 2.61.977 3.58 0 .98-.976.99-2.613 0-3.589ZM1540.17 602.598a2.542 2.542 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.991 3.58 0 .99-.991.99-2.613 0-3.59Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.17 614.343a2.54 2.54 0 0 0-3.58 0 2.549 2.549 0 0 0 0 3.589c.97.991 2.61.977 3.58 0 .99-.99.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.17 685.643a2.54 2.54 0 0 0-3.58 0 2.55 2.55 0 0 0 0 3.59c.97.976 2.61.976 3.58 0 .99-.991.99-2.614 0-3.59ZM1526.1 734.976c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.1 746.721a2.54 2.54 0 0 0-3.59 0c-.97.99-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589ZM1526.1 782.801a2.554 2.554 0 0 0-3.59 0c-.97.977-.97 2.614 0 3.59.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.1 590.854c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589ZM1526.1 570.265c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .99-.99.99-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.1 602.598a2.554 2.554 0 0 0-3.59 0c-.99.991-.97 2.614 0 3.59a2.54 2.54 0 0 0 3.59-3.59ZM1526.1 614.343c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.599 0 3.589.99.991 2.61.977 3.59 0 .99-.99.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.1 626.088a2.552 2.552 0 0 0-3.59 0c-.97.976-.97 2.613 0 3.589.99.991 2.61.976 3.59 0 .99-.991.99-2.613 0-3.589ZM1526.1 637.832a2.54 2.54 0 0 0-3.59 0c-.97.991-.97 2.613 0 3.59.99.99 2.61.99 3.59 0 .97-.991.99-2.614 0-3.59ZM1526.1 580.66c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589.99.991 2.61.977 3.59 0 .97-.976.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.1 685.643c-.99-.991-2.61-.976-3.59 0-.99.991-.97 2.613 0 3.59.99.99 2.61.976 3.59 0 .99-.991.99-2.614 0-3.59ZM1526.1 673.913c-.99-.991-2.61-.976-3.59 0-.97.976-.97 2.613 0 3.589a2.54 2.54 0 0 0 3.59 0c.97-.99.99-2.613 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 846.406c-.99.991-2.61.991-3.58 0-.98-.991-.98-2.613 0-3.59.99-.99 2.61-.976 3.58 0a2.55 2.55 0 0 1 0 3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1414.28 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.99-2.613 0-3.589.99-.977 2.61-.977 3.59 0 .99.99.97 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 846.406c-.99.991-2.61.991-3.58 0-.98-.991-.98-2.613 0-3.589.97-.977 2.61-.977 3.58 0 .99.99.99 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.2 824.712c-.99.99-2.61.976-3.59 0-.99-.991-.97-2.614 0-3.59a2.54 2.54 0 0 1 3.59 0 2.55 2.55 0 0 1 0 3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.97-2.613 0-3.59.99-.99 2.61-.976 3.59 0 .99.991.99 2.614 0 3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1498.11 846.406a2.54 2.54 0 0 1-3.59 0c-.98-.991-.98-2.613 0-3.59.99-.99 2.61-.976 3.59 0 .99.991.97 2.614 0 3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1512.08 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.99-2.613 0-3.589.99-.977 2.62-.977 3.59 0 .99.99.98 2.613 0 3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.3 834.661a2.54 2.54 0 0 1-3.58 0c-.98-.976-.98-2.613 0-3.589a2.54 2.54 0 0 1 3.58 0c.98.976.98 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.25 834.661a2.54 2.54 0 0 1-3.58 0c-.98-.976-.98-2.613 0-3.589.97-.976 2.61-.976 3.58 0 .98.976.99 2.613 0 3.589ZM1456.2 812.981c-.99.991-2.61.977-3.59 0-.99-.99-.97-2.613 0-3.589.99-.991 2.61-.976 3.59 0 .99.991.98 2.613 0 3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1470.17 812.981a2.54 2.54 0 0 1-3.58 0c-.99-.99-.99-2.613 0-3.589a2.54 2.54 0 0 1 3.58 0c.99.991.98 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1484.15 834.661c-.99.991-2.61.977-3.59 0-.97-.976-.97-2.613 0-3.589.99-.991 2.61-.976 3.59 0 .97.976.99 2.613 0 3.589ZM1302.4 844.87c-.99.99-2.61.976-3.59 0-.99-.991-.97-2.613 0-3.59.99-.99 2.62-.976 3.59 0a2.55 2.55 0 0 1 0 3.59ZM1316.38 844.87c-.99.99-2.62.976-3.59 0a2.55 2.55 0 0 1 0-3.59c.99-.99 2.61-.976 3.59 0 .99.991.99 2.613 0 3.59ZM1302.4 833.125c-.99.991-2.61.976-3.59 0-.99-.991-.97-2.613 0-3.589a2.552 2.552 0 0 1 3.59 0c.99.99.98 2.613 0 3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 833.125c-.99.991-2.62.976-3.59 0a2.549 2.549 0 0 1 0-3.589 2.552 2.552 0 0 1 3.59 0c.99.99.99 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 821.395c-.99.991-2.62.991-3.59 0-.98-.991-.98-2.613 0-3.589a2.552 2.552 0 0 1 3.59 0c.99.99.99 2.613 0 3.589ZM1316.38 809.65c-.99.991-2.62.977-3.59 0a2.549 2.549 0 0 1 0-3.589c.99-.991 2.61-.976 3.59 0 .97.976.99 2.613 0 3.589ZM1316.38 797.906c-.99.99-2.62.976-3.59 0a2.55 2.55 0 0 1 0-3.59c.99-.99 2.61-.976 3.59 0 .99.991.99 2.613 0 3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1246.52 797.805c-.99.991-2.61.977-3.59 0-.99-.99-.99-2.613 0-3.589s2.61-.976 3.59 0c.99.991.98 2.613 0 3.589ZM1316.38 786.161c-.99.991-2.62.991-3.59 0a2.549 2.549 0 0 1 0-3.589 2.552 2.552 0 0 1 3.59 0c.99.99.99 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 846.406c-.99.991-2.61.991-3.58 0-.98-.991-.99-2.613 0-3.589.99-.977 2.61-.977 3.58 0 .99.99.98 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1274.47 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.97-2.613 0-3.59.99-.99 2.61-.976 3.59 0 .99.991.97 2.614 0 3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.35 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.97-2.613 0-3.589a2.565 2.565 0 0 1 3.59 0c.99.99.97 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.32 846.406c-.99.991-2.61.991-3.58 0-.98-.991-.98-2.613 0-3.589.97-.977 2.61-.977 3.58 0 .99.99.98 2.613 0 3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 846.406a2.54 2.54 0 0 1-3.59 0c-.98-.991-.99-2.613 0-3.59.99-.99 2.61-.976 3.59 0 .99.991.97 2.614 0 3.59ZM1358.3 822.773c-.99.991-2.61.977-3.59 0-.98-.976-.99-2.613 0-3.589a2.552 2.552 0 0 1 3.59 0c.97.976.97 2.613 0 3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.27 846.406a2.54 2.54 0 0 1-3.59 0c-.97-.991-.97-2.613 0-3.59.99-.99 2.61-.976 3.59 0 .99.991.99 2.614 0 3.59ZM1274.47 834.661c-.99.991-2.61.977-3.59 0-.97-.976-.97-2.613 0-3.589.99-.991 2.61-.976 3.59 0 .99.991.97 2.613 0 3.589ZM1344.32 834.661a2.54 2.54 0 0 1-3.58 0c-.98-.976-.98-2.613 0-3.589.97-.976 2.61-.976 3.58 0 .98.976.98 2.613 0 3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 834.661c-.99.991-2.61.977-3.59 0-.98-.976-.99-2.613 0-3.589.99-.991 2.61-.976 3.59 0 .97.976.97 2.613 0 3.589ZM1372.27 834.661c-.99.991-2.61.977-3.59 0-.97-.976-.97-2.613 0-3.589.99-.991 2.61-.976 3.59 0s.99 2.613 0 3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1540.16 797.92a2.54 2.54 0 0 1-3.59-.043c-.97-1.005-.96-2.613.04-3.589a2.54 2.54 0 0 1 3.55 3.632Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1526.08 797.82c-1 .976-2.61.962-3.58-.044a2.54 2.54 0 0 1 .04-3.589 2.54 2.54 0 0 1 3.59.043 2.541 2.541 0 0 1-.05 3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.486 725.773c-.99-.991-2.611-.991-3.586 0-.976.99-.976 2.613 0 3.589.99.991 2.611.977 3.586 0 .976-.976.976-2.613 0-3.589Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.303 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589a2.548 2.548 0 0 0 3.586 0c.976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.277 644.552a2.548 2.548 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589 2.55 2.55 0 0 0 3.587 0 2.553 2.553 0 0 0 0-3.589ZM526.236 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.976 3.586 0 .976-.976.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.303 679.771a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.277 656.296a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.236 679.771a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.975.977 2.611.977 3.586 0 .976-.976.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.303 691.515c-.99-.99-2.611-.99-3.586 0a2.554 2.554 0 0 0 0 3.59c.99.991 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59ZM512.277 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.975-.976.975-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.303 703.26a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.277 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .976-.976.976-2.613 0-3.589ZM400.486 749.262a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589ZM400.486 737.517a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0c.975-.976.975-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.486 782.801a2.549 2.549 0 0 0-3.586 0c-.976.977-.976 2.614 0 3.59.99.991 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.486 806.276a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59c.99.99 2.611.99 3.587 0a2.555 2.555 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.966 794.532a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.975-.976.975-2.613 0-3.589ZM400.486 840.261a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.46 743.39a2.548 2.548 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.991 3.587 0a2.553 2.553 0 0 0 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.434 715.005a2.548 2.548 0 0 0-3.587 0c-.976.976-.99 2.613 0 3.589s2.611.991 3.587 0c.975-.991.975-2.613 0-3.589ZM428.434 688.974a2.55 2.55 0 0 0-3.587 0c-.976.977-.99 2.613 0 3.59.99.976 2.611.976 3.587 0a2.555 2.555 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.408 715.005a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589s2.611.991 3.587 0c.975-.991.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.381 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.99 2.613 0 3.589.99.991 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.303 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.989.991 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.277 691.515c-.99-.99-2.611-.99-3.587 0a2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59ZM526.236 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.991 3.586 0 .976-.991.99-2.613 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.486 714.028a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.555 2.555 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.408 682.14a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.976.977 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589ZM428.434 668.041a2.548 2.548 0 0 0-3.587 0c-.976.976-.99 2.613 0 3.589s2.611.976 3.587 0c.975-.976.975-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.408 668.041a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589s2.611.976 3.587 0c.975-.976.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.676 705.629c-.99-.991-2.611-.991-3.587 0-.975.991-.975 2.613 0 3.589.976.977 2.611.991 3.587 0 .975-.99.975-2.613 0-3.589ZM236.272 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589.976.976 2.611.976 3.587 0s.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.338 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.99 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.624 644.48a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.587 0 .975-.991.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.583 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.99 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.976-.976.99-2.613 0-3.589Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.557 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.976-.976.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.531 626.088a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0 2.553 2.553 0 0 0 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.504 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.99 2.613 0 3.589s2.611.976 3.586 0c.976-.976.976-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.479 668.041a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.976 3.587 0 .975-.976.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.452 644.552a2.548 2.548 0 0 0-3.587 0c-.989.99-.989 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0 2.553 2.553 0 0 0 0-3.589ZM386.426 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589ZM260.676 717.359a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59c.976.976 2.611.976 3.587 0 .975-.977.975-2.613 0-3.59ZM274.65 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .976-.976.976-2.613 0-3.589ZM288.624 656.224a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.555 2.555 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.583 679.771a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.991 2.611.977 3.587 0 .976-.976.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.531 637.832c-.99-.991-2.611-.991-3.587 0-.975.991-.975 2.613 0 3.59.99.99 2.611.99 3.587 0 .975-.991.975-2.614 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.505 679.771a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.977 2.611.977 3.587 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.479 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.975.977 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.452 656.296a2.55 2.55 0 0 0-3.587 0c-.989.991-.989 2.613 0 3.59a2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59ZM260.676 729.104a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.976.977 2.611.991 3.587 0 .99-.99.975-2.598 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65 691.515c-.99-.99-2.611-.99-3.587 0a2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.624 667.969a2.55 2.55 0 0 0-3.587 0c-.99.991-.976 2.599 0 3.589.99.991 2.611.991 3.587 0 .99-.99.975-2.598 0-3.589Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.583 691.515c-.99-.99-2.611-.99-3.587 0-.99.991-.99 2.614 0 3.59a2.55 2.55 0 0 0 3.587 0c.99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.531 649.562a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.555 2.555 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.505 691.515c-.99-.99-2.611-.99-3.587 0-.99.991-.99 2.614 0 3.59s2.611.976 3.587 0a2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.479 691.515c-.99-.99-2.612-.99-3.587 0a2.554 2.554 0 0 0 0 3.59c.975.976 2.611.976 3.587 0a2.555 2.555 0 0 0 0-3.59ZM260.676 740.848a2.55 2.55 0 0 0-3.587 0 2.555 2.555 0 0 0 0 3.59c.976.976 2.611.976 3.587 0a2.555 2.555 0 0 0 0-3.59ZM274.65 703.26a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .99-.99.976-2.613 0-3.589ZM288.624 679.699a2.55 2.55 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589ZM330.531 661.307a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.991 3.587 0 .99-.99.975-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.505 703.26a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.977 2.611.977 3.587 0 .99-.99.976-2.613 0-3.589ZM358.479 703.26a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.975.977 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.452 679.771a2.55 2.55 0 0 0-3.587 0c-.989.991-.989 2.613 0 3.589.99.991 2.612.977 3.587 0 .976-.976.976-2.613 0-3.589ZM386.426 703.26a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.676 752.593a2.55 2.55 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589.976.977 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589ZM248.338 703.26a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.991 2.611.977 3.587 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.338 715.005a2.548 2.548 0 0 0-3.587 0c-.975.976-.99 2.613 0 3.589.99.991 2.611.991 3.587 0s.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.531 673.051a2.55 2.55 0 0 0-3.587 0c-.975.977-.975 2.614 0 3.59a2.55 2.55 0 0 0 3.587 0 2.555 2.555 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.504 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.99 2.613 0 3.589s2.611.991 3.586 0c.976-.991.976-2.613 0-3.589ZM358.479 715.005a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.991 3.587 0 .975-.991.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.452 691.515c-.99-.99-2.611-.99-3.587 0-.989.991-.989 2.614 0 3.59a2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59ZM386.426 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.328 691.515c-.99-.99-2.611-.99-3.587 0-.99.991-.99 2.614 0 3.59s2.611.976 3.587 0c.99-.991.99-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.328 703.26a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.977 2.611.977 3.587 0 .99-.99.99-2.613 0-3.589ZM554.328 735.191a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.614 0 3.59s2.611.991 3.587 0c.99-.991.99-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.287 703.26a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.589c.976.977 2.612.977 3.587 0 .99-.99.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.261 703.26a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.589.99.977 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589ZM540.253 679.771a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.253 691.515c-.989-.99-2.611-.99-3.586 0a2.554 2.554 0 0 0 0 3.59c.99.991 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.055 717.359a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.59c.976.976 2.611.976 3.587 0 .975-.977.975-2.613 0-3.59Z",
    fill: "#ABABAB",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589ZM856.53 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 691.515c-.989-.99-2.611-.99-3.586 0a2.554 2.554 0 0 0 0 3.59c.975.976 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 611.802a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589ZM832.857 623.546a2.549 2.549 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.975.976 2.611.99 3.586 0 .976-.991.976-2.613 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 635.276a2.549 2.549 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.975.976 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.255 703.26a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.975.977 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.055 740.848a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.59c.976.976 2.611.976 3.587 0a2.555 2.555 0 0 0 0-3.59ZM735.055 729.104a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.976.977 2.611.991 3.587 0 .99-.99.975-2.598 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.029 715.005a2.548 2.548 0 0 0-3.587 0c-.975.976-.99 2.613 0 3.589s2.611.991 3.587 0c.975-.991.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.002 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589ZM763.003 703.26a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0a2.554 2.554 0 0 0 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.977 715.005a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.587 0a2.553 2.553 0 0 0 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M790.95 715.005c-.99-.991-2.597-.977-3.586 0-.99.976-.976 2.613 0 3.589a2.534 2.534 0 0 0 3.586 0c.99-.991.99-2.613 0-3.589Z",
    fill: "#878787",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.975.976 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589ZM832.857 749.262a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.975.977 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.857 761.007c-.989-.991-2.611-.991-3.586 0a2.553 2.553 0 0 0 0 3.589c.975.976 2.611.976 3.586 0a2.553 2.553 0 0 0 0-3.589ZM832.857 833.599a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589ZM807.98 784.481a2.55 2.55 0 0 0-3.587 0c-.99.991-.99 2.613 0 3.59.99.976 2.611.976 3.587 0 .976-.977.99-2.613 0-3.59ZM832.857 796.226a2.548 2.548 0 0 0-3.586 0c-.99.991-.976 2.599 0 3.589.975.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.055 705.629c-.99-.991-2.611-.991-3.587 0s-.976 2.613 0 3.589c.976.977 2.611.991 3.587 0 .975-.99.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.976 682.14a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.612.977 3.587 0 .99-.99.976-2.613 0-3.589ZM763.002 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.977 668.041a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0 2.553 2.553 0 0 0 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.231 629.419a2.548 2.548 0 0 0-3.587 0c-.99.99-.99 2.613 0 3.589.99.991 2.597.976 3.587 0a2.554 2.554 0 0 0 0-3.589ZM570.826 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589a2.548 2.548 0 0 0 3.586 0c.976-.976.976-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.906 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.976 3.586 0 .976-.976.99-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.204 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.178 702.499a2.548 2.548 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.99.99 2.611.976 3.586 0 .976-.977.976-2.614 0-3.59Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.152 668.041a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589a2.55 2.55 0 0 0 3.587 0c.975-.976.975-2.613 0-3.589Z",
    stroke: "#ADADAD",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.126 641.149c-.99-.991-2.612-.991-3.587 0-.99.99-.976 2.599 0 3.589.975.991 2.611.977 3.587 0a2.554 2.554 0 0 0 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.1 668.041a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589s2.611.976 3.587 0c.975-.976.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.073 647.021a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.047 668.041a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.007 631.96a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589.99.991 2.611.991 3.587 0 .975-.99.99-2.613 0-3.589ZM720.981 647.093a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589ZM720.981 623.546a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.59c.99.99 2.611.99 3.587 0 .975-.991.975-2.613 0-3.59ZM595.231 641.149c-.99-.991-2.612-.991-3.587 0a2.54 2.54 0 0 0 0 3.589c.99.991 2.597.977 3.587 0a2.554 2.554 0 0 0 0-3.589ZM609.204 679.771a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.589c.99.991 2.612.977 3.587 0 .976-.976.976-2.613 0-3.589ZM623.178 714.244a2.547 2.547 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.976 3.586 0a2.553 2.553 0 0 0 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.152 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.1 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.976.977 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.073 602.598a2.549 2.549 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.99.991 2.611.991 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.047 679.771a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .976-.976.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.007 679.771a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .975-.976.99-2.613 0-3.589ZM595.231 652.893a2.55 2.55 0 0 0-3.587 0c-.976.977-.99 2.613 0 3.59.99.99 2.597.976 3.587 0a2.556 2.556 0 0 0 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.204 691.515c-.99-.99-2.611-.99-3.587 0a2.556 2.556 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.178 767.654a2.548 2.548 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.99.99 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    fill: "#BABABA",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.152 691.515c-.99-.99-2.611-.99-3.587 0a2.555 2.555 0 0 0 0 3.59 2.55 2.55 0 0 0 3.587 0 2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.1 798.767c-.99-.99-2.611-.99-3.587 0-.976.991-.976 2.613 0 3.59.976.976 2.611.99 3.587 0 .975-.991.975-2.613 0-3.59Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.073 667.179a2.548 2.548 0 0 0-3.586 0 2.554 2.554 0 0 0 0 3.59c.99.99 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.047 823.649a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589ZM595.231 664.638c-.99-.991-2.612-.991-3.587 0-.976.991-.99 2.613 0 3.589.99.991 2.597.977 3.587 0 .989-.976.975-2.613 0-3.589ZM609.204 703.26a2.55 2.55 0 0 0-3.587 0 2.554 2.554 0 0 0 0 3.589c.99.991 2.612.977 3.587 0 .99-.99.976-2.613 0-3.589ZM623.178 737.733a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589a2.548 2.548 0 0 0 3.586 0c.976-.976.976-2.613 0-3.589ZM665.1 703.26a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.976.977 2.611.977 3.587 0 .99-.99.975-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.073 746.146a2.549 2.549 0 0 0-3.586 0c-.976.977-.976 2.613 0 3.59.99.99 2.611.976 3.586 0a2.554 2.554 0 0 0 0-3.59ZM693.047 703.26a2.548 2.548 0 0 0-3.586 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.586 0 .99-.99.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.007 703.26a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0 .99-.99.99-2.613 0-3.589ZM720.981 752.593a2.55 2.55 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.977 3.587 0 .975-.976.975-2.613 0-3.589ZM582.906 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.586 0 .976-.991.99-2.613 0-3.589Z",
    fill: "#6B6B6B",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.1 715.005a2.548 2.548 0 0 0-3.587 0c-.976.976-.976 2.613 0 3.589s2.611.991 3.587 0c.975-.991.975-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.073 757.877a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.976 3.586 0 .976-.976.976-2.613 0-3.589ZM693.047 715.005a2.547 2.547 0 0 0-3.586 0c-.976.976-.976 2.613 0 3.589.99.991 2.611.991 3.586 0 .976-.991.976-2.613 0-3.589Z",
    stroke: "#6B6B6B",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.007 715.005a2.548 2.548 0 0 0-3.587 0c-.975.976-.975 2.613 0 3.589.99.991 2.611.991 3.587 0 .975-.991.99-2.613 0-3.589ZM720.981 682.14a2.55 2.55 0 0 0-3.587 0 2.553 2.553 0 0 0 0 3.589c.99.991 2.611.977 3.587 0a2.554 2.554 0 0 0 0-3.589Z",
    fill: "#BFBFBF",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeMiterlimit: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2086.89 1592.35c-178.06 40.26-386.07-27.52-475.61-186.72-37.55-66.74-52.62-143.77-60.49-219.95-19.85-192.533 2.79-389.506-38.59-578.596-15.75-71.99-53.69-153.469-126.54-164.166-65.31-9.591-122.12 43.82-161.04 97.173-54.36 74.53-96.41 157.546-129.78 243.549-37.91 97.675-65.76 201.237-126.271 286.74-60.515 85.5-165.433 150.65-267.382 126.8-99.037-23.16-160.886-117.77-230.884-191.6-21.018-22.168-45.537-43.963-75.752-48.399-46.283-6.791-87.056 28.457-120.542 61.149",
    stroke: "#5C5C5C",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2089.72 1586.26c-176.65 38.83-382.19-28.04-472.66-184.22-37.93-65.47-54.06-141.07-63.07-215.98-11.89-98.94-12.34-199.302-15.92-299.346-3.27-91.43-9.2-182.544-29.24-271.906-15.98-71.243-53.53-151.143-124.8-163.577-50.46-8.787-96.09 18.837-132.93 55.593-10.41 10.366-20.13 21.422-29.02 32.563-22.08 27.667-42.48 57.043-61.11 87.998-20.91 34.775-39.42 71.459-56.03 108.918a1277.285 1277.285 0 0 0-18.35 43.489c-39.41 98.106-68.64 202.271-130.13 288.428-59.754 84.12-162.593 148.49-262.705 126.61-97.272-21.24-158.748-111.75-228.187-182.5-20.86-21.251-45.106-42.155-74.876-46.319-45.594-6.375-85.88 27.796-119.122 59.409",
    stroke: "#606060",
    strokeWidth: 0.73
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2092.53 1580.16c-175.23 37.39-378.31-28.57-469.69-181.72-38.32-64.23-55.49-138.37-65.65-212.02-13.41-97.28-15.52-196.202-20.34-295.026-4.39-90.295-11.06-180.447-31.41-268.89-16.22-70.511-53.37-148.86-123.05-162.974-50-10.122-95.45 14.315-133 48.572-10.61 9.648-20.61 20.029-29.85 30.567-22.9 26.174-44.3 54.445-63.83 84.926-21.92 34.243-41.12 71.056-58.33 108.644a1301.996 1301.996 0 0 0-19.04 43.662c-40.91 98.551-71.71 203.161-134.003 290.109-59.166 82.62-159.766 146.32-258.042 126.41-95.507-19.31-156.596-105.72-225.475-173.4-20.703-20.317-44.676-40.346-74.001-44.251-44.892-5.973-84.69 27.141-117.702 57.661",
    stroke: "#646464",
    strokeWidth: 0.72
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2095.36 1574.07c-173.83 35.94-374.43-29.09-466.74-179.21-38.72-62.96-56.92-135.67-68.23-208.07-14.93-95.61-18.72-193.098-24.76-290.701-5.51-89.175-12.93-178.365-33.57-265.875-16.46-69.764-53.24-146.621-121.32-162.385-49.57-11.472-94.82 9.792-133.07 41.551-10.83 8.93-21.12 18.636-30.69 28.571-23.7 24.681-46.13 51.86-66.55 81.853-22.93 33.698-42.83 70.64-60.63 108.372a1321.43 1321.43 0 0 0-19.71 43.848c-42.41 98.982-74.678 204.123-137.862 291.806-58.492 81.16-156.926 144.15-253.365 126.2-93.757-17.37-154.444-99.68-222.764-164.29-20.545-19.4-44.246-38.537-73.126-42.17-44.202-5.556-83.498 26.46-116.281 55.92",
    stroke: "#686868",
    strokeWidth: 0.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2098.17 1567.97c-172.42 34.5-370.55-29.61-463.78-176.71-39.11-61.7-58.36-132.97-70.8-204.11-16.46-93.96-21.91-189.983-29.18-286.38-6.61-88.056-14.81-176.27-35.75-262.861-16.69-69.031-53.14-144.423-119.58-161.782-49.14-12.85-94.13 5.356-133.14 34.53-11.04 8.242-21.61 17.244-31.52 26.576-24.52 23.188-47.96 49.276-69.28 78.781-23.95 33.152-44.54 70.223-62.94 108.099-7.08 14.544-13.86 29.232-20.41 44.02-43.91 99.427-77.64 205.085-141.728 293.487-57.803 79.74-154.099 141.98-248.702 126-91.993-15.45-152.307-93.65-220.067-155.19-20.387-18.48-43.815-36.742-72.236-40.087-43.5-5.155-82.308 25.797-114.861 54.187",
    stroke: "#6C6C6C",
    strokeWidth: 0.68
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2101 1561.88c-171.02 33.05-366.67-30.12-460.81-174.21-39.5-60.43-59.8-130.27-73.39-200.15-17.97-92.29-25.09-186.88-33.6-282.055-7.73-86.922-16.67-174.173-37.91-259.845-16.93-68.3-53.03-142.256-117.85-161.194-48.74-14.243-93.48.862-133.22 27.509-11.24 7.538-22.11 15.866-32.36 24.581-25.32 21.694-49.78 46.677-72.02 75.708-24.95 32.606-46.22 69.821-65.23 107.826-7.31 14.601-14.32 29.347-21.08 44.207-45.42 99.858-80.613 206.061-145.59 295.183-57.101 78.3-151.259 139.81-244.026 125.8-90.242-13.53-150.154-87.63-217.355-146.09-20.215-17.55-43.399-34.93-71.361-38.02-42.811-4.738-81.132 25.14-113.441 52.45",
    stroke: "#707070",
    strokeWidth: 0.67
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2103.82 1555.78c-169.61 31.62-362.79-30.64-457.85-171.72-39.88-59.16-61.23-127.56-75.97-196.18-19.49-90.63-28.27-183.78-38-277.735-8.85-85.801-18.55-172.076-40.09-256.83-17.15-67.553-52.94-140.145-116.09-160.59-48.35-15.65-92.85-3.633-133.3 20.474-11.45 6.834-22.61 14.472-33.18 22.584-26.14 20.216-51.62 44.093-74.75 72.636-25.95 32.06-47.93 69.405-67.54 107.553a1301.161 1301.161 0 0 0-21.75 44.38c-46.918 100.302-83.574 207.023-149.469 296.878-56.398 76.88-148.433 137.64-239.363 125.58-88.477-11.6-148.002-81.59-214.644-136.98-20.056-16.63-42.968-33.13-70.486-35.94-42.122-4.34-79.94 24.48-112.02 50.69",
    stroke: "#747474",
    strokeWidth: 0.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2106.63 1549.69c-168.18 30.17-358.9-31.15-454.89-169.22-40.29-57.9-62.65-124.87-78.55-192.22-21.02-88.97-31.48-180.66-42.42-273.41-9.96-84.681-20.42-169.995-42.26-253.815-17.4-66.82-52.85-138.077-114.36-160.002-47.96-17.099-92.22-8.14-133.36 13.454a326.626 326.626 0 0 0-34.02 20.589c-26.99 18.665-53.44 41.507-77.47 69.562-26.96 31.515-49.64 68.989-69.84 107.267a1299.619 1299.619 0 0 0-22.44 44.566c-48.423 100.733-86.528 207.999-153.327 298.549-55.68 75.47-145.592 135.48-234.686 125.39-86.712-9.66-145.864-75.56-211.932-127.88-19.899-15.7-42.538-31.32-69.61-33.87-41.42-3.92-78.75 23.82-110.6 48.96",
    stroke: "#787878",
    strokeWidth: 0.63
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2109.46 1543.59c-166.78 28.73-355.03-31.67-451.93-166.72-40.67-56.64-64.08-122.17-81.13-188.26-22.54-87.31-34.66-177.56-46.84-269.089-11.08-83.562-22.28-167.899-44.42-250.8-17.63-66.074-52.77-136.053-112.62-159.413-47.59-18.564-91.59-12.649-133.44 6.432a315.9 315.9 0 0 0-34.85 18.593c-27.8 17.158-55.26 38.924-80.2 66.491-27.96 30.969-51.33 68.586-72.15 106.993-7.99 14.76-15.68 29.692-23.11 44.739-49.929 101.178-89.469 208.975-157.2 300.244-54.949 74.06-142.766 133.31-230.009 125.19-84.962-7.74-143.712-69.54-209.234-118.78-19.742-14.78-42.108-29.51-68.736-31.79-40.731-3.5-77.574 23.16-109.18 47.22",
    stroke: "#7C7C7C",
    strokeWidth: 0.62
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2112.27 1537.5c-165.37 27.3-351.14-32.19-448.97-164.21-41.06-55.37-65.52-119.47-83.71-184.29-24.06-85.64-37.85-174.46-51.26-264.77-12.2-82.427-24.16-165.802-46.59-247.785-17.87-65.341-52.67-134.071-110.88-158.81-47.22-20.072-90.98-17.143-133.52-.588-12.09 4.709-24.11 10.265-35.68 16.597-28.61 15.664-57.1 36.325-82.92 63.432-28.98 30.439-53.04 68.17-74.45 106.721-8.22 14.817-16.14 29.806-23.8 44.925-51.419 101.609-92.408 209.966-161.057 301.928-54.231 72.65-139.925 131.14-225.346 124.98-83.198-5.81-141.561-63.5-206.523-109.68-19.584-13.84-41.678-27.69-67.847-29.72-40.027-3.1-76.382 22.5-107.759 45.49",
    stroke: "gray",
    strokeWidth: 0.6
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2115.1 1531.4c-163.97 25.85-347.27-32.71-446-161.71-41.47-54.11-66.96-116.77-86.28-180.35-25.57-83.97-41.04-171.35-55.68-260.444-13.32-81.307-26.03-163.72-48.76-244.769-18.1-64.595-52.58-132.148-109.13-158.222-46.86-21.593-90.34-21.651-133.59-7.609a292.787 292.787 0 0 0-36.51 14.602c-29.42 14.156-58.92 33.74-85.65 60.359-29.98 29.893-54.73 67.754-76.75 106.448-8.46 14.875-16.6 29.921-24.48 45.097-52.926 102.055-95.35 210.943-164.932 303.618-53.485 71.25-137.099 128.98-220.669 124.79-81.433-3.88-139.423-57.48-203.812-100.58-19.411-12.92-41.247-25.89-66.971-27.64-39.339-2.68-75.192 21.84-106.339 43.75",
    stroke: "#848484",
    strokeWidth: 0.58
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2117.92 1525.31c-162.55 24.41-343.37-33.22-443.04-159.21-41.85-52.85-68.39-114.07-88.86-176.38-27.09-82.33-44.24-168.25-60.1-256.129-14.42-80.187-27.91-161.624-50.92-241.754-18.34-63.863-52.48-130.253-107.4-157.619-46.49-23.158-89.73-26.159-133.66-14.63-12.52 3.288-25.1 7.48-37.34 12.606-30.23 12.663-60.75 31.156-88.38 57.287-30.99 29.347-56.44 67.352-79.05 106.175-8.69 14.918-17.06 30.036-25.15 45.284-54.432 102.485-98.275 211.934-168.79 305.3-52.754 69.84-134.258 126.79-216.007 124.58-79.682-1.95-137.27-51.44-201.114-91.47-19.253-11.99-40.817-24.08-66.096-25.56-38.636-2.28-74.001 21.18-104.918 42",
    stroke: "#888",
    strokeWidth: 0.57
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2120.74 1519.21c-161.15 22.96-339.51-33.74-440.09-156.71-42.24-51.59-69.83-111.37-91.45-172.42-28.61-80.66-47.42-165.15-64.5-251.794-15.54-79.053-29.77-159.528-53.1-238.739-18.58-63.131-52.38-128.415-105.67-157.03-46.11-24.752-89.1-30.682-133.72-21.665-12.74 2.57-25.6 6.087-38.18 10.61-31.05 11.17-62.58 28.557-91.1 54.214-32 28.802-58.15 66.936-81.35 105.903a1313.509 1313.509 0 0 0-25.838 45.456C939.804 839.951 894.54 949.973 823.078 1044.03c-51.993 68.44-131.432 124.63-211.329 124.38-77.918-.03-135.119-45.41-198.403-82.37-19.096-11.07-40.401-22.27-65.221-23.49-37.947-1.86-72.824 20.52-103.498 40.26",
    stroke: "#8C8C8C",
    strokeWidth: 0.55
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2123.56 1513.12c-159.73 21.53-335.61-34.27-437.12-154.21-42.64-50.32-71.26-108.67-94.03-168.46-30.12-79-50.6-162.04-68.92-247.468-16.66-77.934-31.65-157.432-55.26-235.725-18.81-62.384-52.25-126.62-103.93-156.441-45.72-26.375-88.49-35.205-133.8-28.686-12.96 1.866-26.1 4.695-39.01 8.614-31.85 9.677-64.4 25.973-93.84 51.142-33 28.256-59.84 66.519-83.66 105.63-9.15 15.032-17.961 30.251-26.512 45.643-57.43 103.36-104.115 213.929-176.523 308.671-51.247 67.05-128.591 122.46-206.667 124.17-76.167 1.91-132.981-39.38-195.691-73.27-18.938-10.13-39.97-20.47-64.346-21.41-37.258-1.46-71.634 19.86-102.078 38.53",
    stroke: "#909090",
    strokeWidth: 0.53
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2126.38 1507.02c-158.34 20.07-331.73-34.79-434.17-151.72-43.03-49.07-72.7-105.97-96.61-164.49-31.65-77.33-53.79-158.93-73.34-243.148-17.76-76.814-33.52-155.35-57.43-232.709-19.06-61.652-52.11-124.855-102.18-155.838-45.32-28.041-87.89-39.728-133.89-35.708-13.17 1.149-26.58 3.302-39.84 6.619-32.65 8.184-66.22 23.389-96.57 48.069-34.01 27.711-61.54 66.118-85.95 105.357-9.381 15.076-18.419 30.366-27.185 45.815-58.937 103.792-107.028 214.935-180.398 310.373-50.486 65.67-125.764 120.29-201.989 123.96-74.403 3.83-130.829-33.37-192.994-64.16-18.78-9.22-39.54-18.67-63.471-19.34-36.555-1.05-70.443 19.19-100.657 36.78",
    stroke: "#949494",
    strokeWidth: 0.52
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2129.2 1500.92c-156.92 18.64-327.85-35.31-431.21-149.2-43.41-47.82-74.13-103.28-99.19-160.54-33.17-75.68-56.99-155.82-77.76-238.823-18.88-75.694-35.38-153.254-59.6-229.694-19.28-60.905-51.95-123.131-100.44-155.25-44.91-29.734-87.27-44.25-133.96-42.728-13.38.431-27.08 1.91-40.67 4.623-33.46 6.691-68.06 20.79-99.3 44.997-35.02 27.165-63.25 65.701-88.258 105.084-9.612 15.133-18.88 30.481-27.876 46.002-60.443 104.237-109.925 215.953-184.256 312.049-49.712 64.29-122.924 118.12-197.327 123.76-72.638 5.76-128.62-27.45-190.283-55.06-18.593-8.33-39.109-16.85-62.581-17.26-35.867-.64-69.252 18.54-99.251 35.05",
    stroke: "#989898",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2132.01 1494.83c-155.5 17.2-323.96-35.82-428.24-146.7-43.8-46.55-75.55-100.58-101.77-156.59-34.69-74.01-60.17-152.72-82.18-234.503-20-74.559-37.26-151.157-61.76-226.679-19.53-60.172-51.77-121.451-98.71-154.646-44.46-31.458-86.66-48.773-134.03-49.749-13.61-.273-27.57.517-41.5 2.627-34.28 5.198-69.89 18.206-102.03 41.925-36.02 26.633-64.94 65.284-90.553 104.811-9.842 15.19-19.339 30.596-28.55 46.174-61.95 104.667-112.824 216.959-188.13 313.74-48.952 62.92-120.098 115.96-192.65 123.57-70.888 7.69-126.482-21.44-187.571-45.96-18.435-7.41-38.679-15.05-61.706-15.18-35.164-.23-68.075 17.88-97.831 33.3",
    stroke: "#9C9C9C",
    strokeWidth: 0.48
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2134.84 1488.73c-154.1 15.75-320.09-36.34-425.28-144.21-44.21-45.28-76.99-97.87-104.35-152.62-36.21-72.35-63.35-149.61-86.58-230.182-21.12-73.44-39.13-149.061-63.93-223.664-19.76-59.441-51.56-119.786-96.97-154.058-44-33.209-86.04-53.31-134.1-56.784-13.83-.991-28.08-.876-42.34.632-35.08 3.704-71.71 15.621-104.75 38.851-37.03 26.088-66.65 64.883-92.863 104.539-10.072 15.247-19.799 30.711-29.239 46.346C890.996 822.693 838.73 935.558 762.448 1033c-48.177 61.54-117.257 113.79-187.987 123.36-69.123 9.62-124.344-15.4-184.873-36.85-18.278-6.48-38.249-13.24-60.831-13.11-34.476.19-66.885 17.21-96.411 31.56",
    stroke: "#A0A0A0",
    strokeWidth: 0.47
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2137.67 1482.64c-152.7 14.32-316.21-36.85-422.32-141.71-44.59-44.02-78.42-95.17-106.93-148.66-37.73-70.68-66.54-146.5-91-225.857-22.22-72.32-41-146.98-66.09-220.649-20-58.694-51.32-118.163-95.22-153.454-43.52-34.99-85.42-57.848-134.18-63.806-14.04-1.709-28.56-2.268-43.16-1.364-35.89 2.211-73.55 13.022-107.48 35.794-38.03 25.542-68.35 64.466-95.16 104.265-10.301 15.291-20.243 30.826-29.913 46.533-64.948 105.544-118.591 219.012-195.863 317.118-47.388 60.17-114.431 111.62-183.31 123.16-67.359 11.54-122.192-9.38-182.162-27.75-18.12-5.56-37.833-11.43-59.956-11.03-33.772.59-65.694 16.55-94.99 29.82",
    stroke: "#A4A4A4",
    strokeWidth: 0.45
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2140.48 1476.54c-151.29 12.87-312.33-37.37-419.36-139.21-44.98-42.76-79.86-92.48-109.51-144.7-39.25-69.03-69.74-143.4-95.42-221.536-23.34-71.186-42.87-144.884-68.28-217.634-20.23-57.962-51.06-116.555-93.48-152.866-43-36.799-84.81-62.384-134.25-70.826-14.26-2.427-29.06-3.662-44-3.36-36.68.732-75.36 10.438-110.2 32.721-39.05 24.997-70.051 64.05-97.468 103.993-10.531 15.348-20.703 30.94-30.588 46.705-66.454 105.988-121.46 220.046-199.722 318.793-46.599 58.8-111.59 109.45-178.647 122.95-65.609 13.48-120.055-3.35-179.451-18.65-17.962-4.62-37.402-9.62-59.08-8.96-33.084 1-64.504 15.89-93.57 28.08",
    stroke: "#A8A8A8",
    strokeWidth: 0.43
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2143.3 1470.45c-149.86 11.43-308.44-37.89-416.4-136.7-45.38-41.49-81.29-89.77-112.09-140.73-40.76-67.37-72.93-140.29-99.84-217.217-24.46-70.066-44.75-142.787-70.44-214.619-20.46-57.215-50.78-114.976-91.75-152.277-42.45-38.636-84.18-66.935-134.32-77.847-14.47-3.145-29.55-5.011-44.83-5.356-37.5-.689-77.19 7.854-112.94 29.649-40.06 24.451-71.763 63.648-99.768 103.72-10.76 15.406-21.161 31.055-31.276 46.892C861.699 812.384 805.33 927.059 726.05 1026.46c-45.81 57.44-108.764 107.28-173.97 122.74-63.844 15.41-117.917 2.69-176.739-9.55-17.804-3.7-36.972-7.81-58.191-6.87-32.395 1.4-63.327 15.23-92.15 26.34",
    stroke: "#ACACAC",
    strokeWidth: 0.42
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2146.12 1464.35c-148.47 9.98-304.57-38.41-413.44-134.2-45.76-40.23-82.72-87.08-114.67-136.77-42.28-65.7-76.11-137.19-104.26-212.897-25.57-68.945-46.61-140.705-72.61-211.603-20.7-56.483-50.44-113.397-90-151.674-41.85-40.503-83.55-71.473-134.38-84.868a235.463 235.463 0 0 0-45.67-7.352c-38.31-2.182-79.02 5.255-115.67 26.577-41.06 23.905-73.451 63.231-102.059 103.446-10.989 15.449-21.62 31.171-31.95 47.065-69.453 106.864-127.171 222.142-207.456 322.176-45.006 56.08-105.923 105.11-169.293 122.54-62.078 17.33-115.779 8.71-174.041-.45-17.647-2.77-36.542-6-57.316-4.79-31.692 1.82-62.136 14.56-90.73 24.59",
    stroke: "#B0B0B0",
    strokeWidth: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2148.94 1458.26c-147.05 8.55-300.68-38.92-410.48-131.7-46.15-38.97-84.15-84.38-117.25-132.81-43.8-64.05-79.3-134.08-108.67-208.557-26.68-67.826-48.47-138.609-74.77-208.588-20.93-55.737-50.09-111.847-88.26-151.086-41.24-42.384-82.93-76.024-134.46-91.889a235.712 235.712 0 0 0-46.5-9.347c-39.12-3.676-80.84 2.671-118.39 23.504-42.07 23.359-75.164 62.814-104.374 103.174-11.219 15.506-22.08 31.285-32.639 47.251-70.96 107.295-130.011 223.204-211.329 323.868-44.217 54.73-103.097 102.94-164.631 122.34-60.328 19.27-113.641 14.76-171.33 8.66-17.488-1.86-36.111-4.21-56.44-2.73-31.004 2.22-60.946 13.9-89.31 22.86",
    stroke: "#B4B4B4",
    strokeWidth: 0.38
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2151.77 1452.16c-145.65 7.11-296.81-39.45-407.52-129.2-46.54-37.71-85.6-81.68-119.83-128.86-45.32-62.39-82.49-130.97-113.08-204.241-27.8-66.691-50.36-136.513-76.94-205.573-21.18-55.004-49.71-110.296-86.53-150.483-40.56-44.279-82.29-80.561-134.54-98.924-15.11-5.312-31.05-9.189-47.33-11.343-39.95-5.168-82.67.087-121.12 20.431-43.07 22.815-76.87 62.413-106.669 102.902-11.448 15.564-22.524 31.4-33.313 47.423-72.466 107.74-132.837 224.281-215.188 325.558-43.414 53.38-100.256 100.78-159.953 122.14-58.564 21.19-111.504 20.79-168.619 17.76-17.331-.92-35.681-2.39-55.566-.64-30.3 2.64-59.769 13.23-87.888 21.12",
    stroke: "#B8B8B8",
    strokeWidth: 0.37
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2154.58 1446.07c-144.24 5.66-292.92-39.97-404.55-126.7-46.94-36.44-87.02-78.98-122.41-124.9-46.84-60.72-85.68-127.87-117.5-199.916-28.91-65.572-52.22-134.417-79.11-202.558-21.4-54.272-49.28-108.745-84.79-149.894-39.85-46.189-81.66-85.112-134.61-105.945-15.33-6.031-31.55-10.582-48.17-13.339-40.74-6.662-84.5-2.512-123.84 17.359-44.087 22.283-78.563 61.996-108.978 102.628-11.693 15.622-22.984 31.516-33.988 47.61-73.958 108.171-135.649 225.358-219.062 327.245-42.596 52.03-97.43 98.6-155.29 121.94-56.814 23.11-109.352 26.93-165.922 26.86-17.173.04-35.25-.59-54.69 1.42-29.612 3.04-58.578 12.58-86.468 19.38",
    stroke: "#BCBCBC",
    strokeWidth: 0.35
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M2157.41 1439.97c-142.83 4.22-289.05-40.49-401.6-124.21-47.33-35.17-88.45-76.28-124.99-120.93-48.36-59.05-88.86-124.77-121.92-195.596-30.03-64.451-54.1-132.334-81.27-199.542-21.65-53.526-48.84-107.209-83.04-149.306-39.1-48.112-80.99-89.764-134.69-112.966a238.94 238.94 0 0 0-49-15.334c-41.56-8.141-86.32-5.097-126.56 14.286-45.097 21.737-80.275 61.58-111.279 102.356-11.922 15.664-23.443 31.63-34.676 47.782-75.465 108.616-138.462 226.449-222.922 328.93-41.778 50.7-94.589 96.43-150.613 121.74-55.049 25.04-107.214 32.97-163.21 35.97-17.015.96-34.834 1.22-53.801 3.5-28.909 3.46-57.387 11.92-85.048 17.63",
    stroke: "silver",
    strokeWidth: 0.33
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2160.22 1433.88c-141.42 2.78-285.16-41-398.63-121.69-47.72-33.91-89.88-73.58-127.57-116.97-49.88-57.41-92.05-121.66-126.34-191.28-31.15-63.314-55.97-130.235-83.45-196.524-21.88-52.793-48.37-105.658-81.31-148.702-38.3-50.051-80.35-94.287-134.76-119.987a242.122 242.122 0 0 0-49.82-17.33c-42.37-9.634-88.15-7.681-129.3 11.228-46.095 21.192-81.962 61.178-113.583 102.083-12.152 15.721-23.902 31.73-35.351 47.969-76.97 109.046-141.244 227.554-226.795 330.613-40.96 49.35-91.762 94.26-145.95 121.52-53.284 26.98-105.062 39-160.499 45.07-16.843 1.9-34.403 3.03-52.925 5.59-28.22 3.86-56.197 11.25-83.628 15.89",
    stroke: "#C4C4C4",
    strokeWidth: 0.32
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2163.05 1427.78c-140.02 1.34-281.29-41.52-395.68-119.2-48.12-32.66-91.31-70.88-130.15-113-51.41-55.74-95.25-118.56-130.74-186.96-32.27-62.193-57.85-128.138-85.63-193.508-22.1-52.047-47.84-104.108-79.56-148.114-37.48-51.989-79.74-98.809-134.84-127.008a245.327 245.327 0 0 0-50.65-19.325c-43.19-11.127-89.99-10.28-132.02 8.155-47.105 20.646-83.675 60.762-115.884 101.81-12.381 15.779-24.346 31.846-36.025 48.141-78.477 109.492-144.014 228.675-230.654 332.309-40.143 48.01-88.922 92.09-141.274 121.32-51.534 28.9-102.91 45.03-157.801 54.17-16.685 2.82-33.973 4.84-52.05 7.66-27.517 4.27-55.02 10.59-82.208 14.15",
    stroke: "#C8C8C8",
    strokeWidth: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2165.87 1421.69c-138.6-.11-277.39-42.03-392.71-116.69-48.51-31.4-92.76-68.19-132.74-109.05-52.93-54.07-98.44-115.45-135.16-182.63-33.37-61.078-59.72-126.047-87.79-190.498-22.35-51.314-47.32-102.542-77.83-147.511-36.6-53.941-79.11-103.346-134.91-134.043a249.659 249.659 0 0 0-51.49-21.321c-43.99-12.62-91.8-12.865-134.76 5.083-48.103 20.1-85.376 60.345-118.187 101.537-12.611 15.837-24.806 31.96-36.714 48.328-79.969 109.922-146.783 229.809-234.528 333.985-39.325 46.69-86.095 89.92-136.611 121.12-49.769 30.83-100.772 51.06-155.089 63.28-16.528 3.75-33.543 6.65-51.176 9.73-26.828 4.7-53.829 9.94-80.787 12.42",
    stroke: "#CCC",
    strokeWidth: 0.28
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M2168.68 1415.59c-137.18-1.55-273.52-42.55-389.74-114.2-48.9-30.14-94.19-65.48-135.32-105.1-54.45-52.4-101.62-112.33-139.58-178.3-34.49-59.962-61.58-123.968-89.96-187.487-22.58-50.582-46.75-100.977-76.08-146.922-35.68-55.88-78.48-107.869-134.97-141.064a255.932 255.932 0 0 0-52.33-23.317c-44.8-14.113-93.62-15.449-137.48 2.01-49.127 19.556-87.074 59.944-120.488 101.265-12.841 15.88-25.265 32.075-37.388 48.5-81.476 110.368-149.365 231.087-238.388 335.685-38.42 45.41-83.269 87.75-131.933 120.92-48.005 32.76-98.62 57.08-152.378 72.37-16.37 4.67-33.113 8.46-50.3 11.81-26.14 5.09-52.639 9.27-79.367 10.68",
    stroke: "#D0D0D0",
    strokeWidth: 0.27
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2171.51 1409.5c-268.53-5.91-529.53-156.9-668.68-386.81-63.94-105.653-102.88-224.908-166.46-330.796-34.72-57.818-77.85-112.391-135.05-148.085-57.2-35.693-130.33-50.28-193.37-26.375-50.127 19.01-88.777 59.527-122.779 100.992C784.284 741.443 708.26 883.569 604.848 1004.48c-103.412 120.9-245.289 223.07-404.309 225.01",
    stroke: "#D4D4D4",
    strokeWidth: 0.25
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M199.277 793.094c66.814-88.156 176.008-137.116 279.032-145.659 103.025-8.557 201.014 18.608 291.643 55.435 75.436 30.654 148.046 68.343 229.134 85.429 81.084 17.071 174.474 10.94 250.324-40.044 71.35-47.94 117.07-128.616 142.62-209.004 25.55-80.403 34.12-162.888 51.12-244.44 22.94-110.037 64.4-223.65 145.94-307.57 81.53-83.92 210.88-128.63 301.39-80.374 50.41 26.863 84.05 78.493 138.01 98.838",
    stroke: "#000"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M199.995 797.387c66.354-88.199 174.802-137.704 277.439-147.152 75.594-6.92 148.634 5.399 218.087 26.792 24.791 7.638 49.109 16.425 72.939 25.887 75.436 29.95 148.103 66.964 229.076 83.346 80.914 16.396 173.784 9.648 249.324-41.307 71.06-47.94 116.87-128.185 142.7-208.229a645.898 645.898 0 0 0 6.22-20.36c21.2-73.554 30.11-148.673 46.06-222.945 2.73-12.678 5.7-25.385 8.94-38.106 21.77-85.141 56.14-170.023 112.97-239.012a419.806 419.806 0 0 1 25.48-28.256c81.78-82.858 210.47-126.247 301.1-78.608 50.37 26.519 84.3 77.273 138.16 97.144",
    stroke: "#020202"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.727 801.694c65.895-88.242 173.597-138.307 275.861-148.645 75.264-7.552 148.117 3.992 217.513 24.724 24.762 7.395 49.08 15.952 72.91 25.198 75.436 29.247 148.16 65.586 229.005 81.264 80.734 15.708 173.084 8.357 248.314-42.57 70.79-47.94 116.66-127.755 142.81-207.44 2.21-6.748 4.3-13.496 6.3-20.273 21.49-73.209 30.82-147.998 47.16-221.912a978.079 978.079 0 0 1 9.14-37.904c22.2-84.724 57.02-169.105 114.08-237.332a423.6 423.6 0 0 1 25.58-27.926C1671.42-92.917 1799.47-135 1890.2-87.95c50.33 26.16 84.54 76.067 138.33 95.45",
    stroke: "#050505"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M201.444 805.987c65.436-88.271 172.392-138.91 274.269-150.138 74.919-8.169 147.615 2.599 216.939 22.657 24.748 7.15 49.051 15.492 72.882 24.508 75.435 28.543 148.203 64.208 228.947 79.183 80.539 15.032 172.389 7.078 247.299-43.849 70.5-47.926 116.45-127.338 142.89-206.664a683.58 683.58 0 0 0 6.37-20.172c21.77-72.866 31.52-147.339 48.25-220.893 2.86-12.549 5.95-25.14 9.33-37.718 22.65-84.294 57.9-168.171 115.22-235.652a421.964 421.964 0 0 1 25.69-27.595c82.27-80.734 209.67-121.495 300.5-75.048 50.3 25.815 84.79 74.847 138.5 93.741",
    stroke: "#070707"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M202.175 810.295c64.963-88.314 171.187-139.5 272.677-151.632 74.575-8.787 147.112 1.192 216.35 20.604 24.734 6.92 49.024 15.032 72.854 23.819 75.435 27.839 148.26 62.829 228.875 77.115 80.369 14.343 171.699 5.786 246.289-45.112 70.23-47.926 116.24-126.907 143-205.874 2.27-6.677 4.4-13.382 6.44-20.087 22.05-72.52 32.22-146.678 49.34-219.859 2.93-12.491 6.08-25.011 9.53-37.531 23.09-83.877 58.79-167.252 116.35-233.972A420.447 420.447 0 0 1 1589.69-9.5c82.49-79.671 209.26-119.111 300.19-73.267 50.27 25.456 85.05 73.64 138.66 92.046",
    stroke: "#090909"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M202.893 814.588c64.503-88.343 169.981-140.103 271.083-153.125 74.245-9.419 146.597-.201 215.777 18.536 24.705 6.676 48.995 14.558 72.825 23.13 75.436 27.136 148.318 61.451 228.818 75.033 80.184 13.669 171.014 4.508 245.284-46.375 69.94-47.926 116.04-126.477 143.09-205.085 2.28-6.648 4.44-13.31 6.52-19.986 22.34-72.176 32.93-146.003 50.43-218.825 2.99-12.434 6.23-24.896 9.73-37.33 23.54-83.461 59.67-166.334 117.49-232.293a412.185 412.185 0 0 1 25.91-26.935c82.73-78.608 208.86-116.727 299.89-71.486 50.23 25.111 85.29 72.42 138.83 90.338",
    stroke: "#0C0C0C"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M203.625 818.895c64.044-88.386 168.79-140.705 269.505-154.618 73.901-10.036 146.094-1.608 215.203 16.468 24.691 6.433 48.966 14.1 72.796 22.441 75.436 26.433 148.375 60.073 228.746 72.952 79.995 12.979 170.315 3.216 244.265-47.639 69.66-47.926 115.83-126.06 143.17-204.31a673.25 673.25 0 0 0 6.6-19.899c22.61-71.832 33.63-145.343 51.52-217.806 3.06-12.362 6.36-24.767 9.93-37.143 23.99-83.045 60.56-165.4 118.62-230.599A414.076 414.076 0 0 1 1590-7.863c82.99-77.545 208.45-114.344 299.6-69.72 50.2 24.752 85.55 71.214 139 88.644",
    stroke: "#0E0E0E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M204.342 823.188c63.585-88.429 167.585-141.294 267.913-156.111 73.571-10.654 145.592-3.001 214.629 14.401 24.662 6.202 48.937 13.625 72.767 21.751 75.436 25.729 148.433 58.695 228.689 70.884 79.83 12.305 169.62 1.939 243.27-48.902 69.38-47.911 115.62-125.63 143.26-203.52 2.34-6.59 4.55-13.18 6.67-19.799 22.9-71.487 34.32-144.682 52.61-216.772a1022.78 1022.78 0 0 1 10.12-36.957c24.45-82.614 61.45-164.481 119.74-228.918a412.05 412.05 0 0 1 26.12-26.275c83.23-76.483 208.05-111.961 299.29-67.94 50.16 24.408 85.8 69.993 139.17 86.935",
    stroke: "#101010"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M205.073 827.495c63.126-88.458 166.381-141.897 266.321-157.604 73.226-11.285 145.09-4.394 214.055 12.333 24.648 5.959 48.908 13.166 72.739 21.077 75.435 25.026 148.475 57.316 228.617 68.802 79.635 11.615 168.935.646 242.265-50.166 69.09-47.911 115.42-125.198 143.35-202.744a747.51 747.51 0 0 0 6.76-19.713c23.18-71.142 35.02-144.022 53.7-215.738a977.817 977.817 0 0 1 10.31-36.77c24.89-82.198 62.33-163.563 120.87-227.24a405.313 405.313 0 0 1 26.25-25.943c83.45-75.421 207.64-109.578 298.98-66.16 50.13 24.048 86.04 68.787 139.34 85.24",
    stroke: "#131313"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M205.791 831.788c62.653-88.501 165.175-142.5 264.728-159.097 72.897-11.903 144.574-5.801 213.482 10.265 24.633 5.729 48.879 12.707 72.709 20.388 75.436 24.322 148.533 55.952 228.56 66.72 79.45 10.941 168.25-.631 241.24-51.429 68.82-47.911 115.21-124.768 143.44-201.955a724.589 724.589 0 0 0 6.83-19.612c23.46-70.798 35.73-143.347 54.79-214.719a995.948 995.948 0 0 1 10.52-36.569c25.33-81.781 63.21-162.63 122-225.56 8.4-8.93 17.18-17.472 26.36-25.613 83.7-74.358 207.33-107.381 298.69-64.38 50.14 23.604 86.29 67.567 139.51 83.533",
    stroke: "#151515"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M206.522 836.095c62.194-88.529 163.971-143.088 263.151-160.59 72.552-12.52 144.071-7.193 212.893 8.212 24.604 5.485 48.851 12.233 72.681 19.699 75.436 23.604 148.59 54.574 228.488 64.653 79.285 10.251 167.555-1.924 240.235-52.693 68.54-47.897 115.01-124.352 143.54-201.165a644.76 644.76 0 0 0 6.9-19.527c23.75-70.453 36.43-142.686 55.89-213.685a999.447 999.447 0 0 1 10.7-36.382c25.78-81.365 64.1-161.71 123.14-223.879a408.686 408.686 0 0 1 26.45-25.284c83.95-73.296 206.93-105.026 298.37-62.614 50.12 23.245 86.54 66.361 139.67 81.839",
    stroke: "#171717"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M207.24 840.388c61.734-88.572 162.722-143.892 261.557-162.083 72.194-13.296 143.569-8.601 212.32 6.145 24.59 5.24 48.822 11.773 72.652 19.009 75.436 22.901 148.648 53.195 228.431 62.571 79.09 9.576 166.85-3.216 239.23-53.956 68.27-47.897 114.79-123.921 143.63-200.39a792.924 792.924 0 0 0 6.99-19.426c24.03-70.109 37.13-142.026 56.97-212.651a974.898 974.898 0 0 1 10.9-36.196c26.23-80.934 64.86-160.906 124.26-222.2 8.48-8.743 17.35-17.042 26.57-24.953 84.19-72.233 206.52-102.657 298.07-60.833 50.09 22.886 86.78 65.14 139.84 80.144",
    stroke: "#191919"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M207.972 844.696c61.275-88.616 161.517-144.51 259.965-163.577 71.849-13.927 143.067-9.993 211.745 4.077 24.576 5.011 48.794 11.314 72.624 18.321 75.436 22.197 148.691 51.816 228.359 60.488 78.905 8.888 166.165-4.493 238.215-55.219 67.98-47.897 114.59-123.49 143.73-199.6a770.01 770.01 0 0 0 7.06-19.326c24.31-69.764 37.83-141.365 58.06-211.632a953.763 953.763 0 0 1 11.1-35.994c26.67-80.518 65.74-159.988 125.39-220.52a391.356 391.356 0 0 1 26.69-24.638c84.43-71.17 206.13-100.288 297.77-59.053 50.05 22.513 87.04 63.935 139.99 78.436",
    stroke: "#1C1C1C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M208.689 848.988c60.816-88.644 160.312-145.113 258.373-165.07 71.504-14.558 142.55-11.4 211.171 2.01 24.547 4.767 48.765 10.84 72.581 17.632 75.421 21.493 148.748 50.438 228.301 58.407 78.725 8.212 165.475-5.787 237.215-56.483 67.7-47.883 114.38-123.074 143.81-198.825 2.48-6.39 4.85-12.807 7.13-19.24 24.59-69.405 38.54-140.69 59.15-210.598 3.53-11.945 7.28-23.891 11.31-35.808 27.11-80.101 66.61-159.083 126.52-218.84a389.042 389.042 0 0 1 26.79-24.307c84.66-70.109 205.73-97.919 297.47-57.273 50.01 22.154 87.28 62.715 140.16 76.742",
    stroke: "#1E1E1E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M209.42 853.296c60.343-88.688 159.107-145.731 256.795-166.563 71.16-15.177 142.048-12.793 210.597-.058 24.533 4.523 48.737 10.381 72.552 16.942 75.422 20.79 148.82 48.888 228.23 56.34 78.566 7.365 164.786-7.064 236.206-57.747 67.42-47.883 114.17-122.643 143.9-198.035a708 708 0 0 0 7.22-19.139c24.87-69.06 39.24-140.03 60.24-209.579 3.59-11.874 7.42-23.762 11.49-35.621 27.56-79.685 67.49-158.164 127.66-217.16 8.61-8.442 17.59-16.41 26.9-23.977 84.9-69.046 205.33-95.55 297.17-55.493 49.98 21.795 87.53 61.509 140.34 75.034",
    stroke: "#202020"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M210.138 857.589c59.883-88.716 157.887-146.334 255.202-168.057 70.816-15.808 141.546-14.185 210.009-2.125 24.504 4.293 48.708 9.907 72.523 16.253 75.422 20.087 148.878 47.51 228.173 54.258 78.375 6.676 164.085-8.356 235.185-59.01 67.15-47.883 113.97-122.213 144-197.26a719.463 719.463 0 0 0 7.29-19.053c25.16-68.716 39.94-139.37 61.33-208.545a979.21 979.21 0 0 1 11.7-35.435c28-79.254 68.36-157.245 128.79-215.465 8.65-8.342 17.66-16.196 27.01-23.647 85.15-67.97 204.93-93.181 296.87-53.727 49.95 21.436 87.79 60.288 140.5 73.34",
    stroke: "#232323"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M210.87 861.896c59.424-88.759 156.682-146.951 253.609-169.55 70.486-16.439 141.03-15.592 209.435-4.178 24.491 4.049 48.665 9.448 72.495 15.578 75.422 19.383 148.935 46.117 228.101 52.176 78.19 5.987 163.4-9.634 234.18-60.288 66.86-47.868 113.76-121.781 144.09-196.47 2.55-6.303 5.01-12.62 7.36-18.952 25.44-68.371 40.64-138.71 62.42-207.511 3.73-11.759 7.68-23.518 11.9-35.234 28.45-78.838 69.25-156.34 129.91-213.786 8.69-8.227 17.74-15.98 27.11-23.317 85.39-66.906 204.53-90.812 296.57-51.946 49.92 21.092 88.03 59.082 140.67 71.63",
    stroke: "#252525"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M211.587 866.189c58.965-88.802 155.477-147.554 252.017-171.043 70.142-17.071 140.527-16.985 208.861-6.246 24.476 3.805 48.636 8.988 72.466 14.889 75.422 18.68 148.978 44.739 228.044 50.109 78.015 5.298 162.705-10.927 233.165-61.552 66.58-47.868 113.56-121.365 144.17-195.68a771.783 771.783 0 0 0 7.45-18.866c25.72-68.027 41.35-138.035 63.51-206.492 3.8-11.687 7.81-23.389 12.08-35.047 28.9-78.422 70.13-155.422 131.05-212.106 8.73-8.127 17.83-15.765 27.23-22.987 85.62-65.844 204.12-88.443 296.26-50.165 49.88 20.732 88.27 57.861 140.84 69.936",
    stroke: "#272727"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M212.319 870.496c58.506-88.831 154.257-148.157 250.439-172.536 69.797-17.703 140.025-18.392 208.287-8.313 24.447 3.575 48.607 8.514 72.438 14.2 75.421 17.976 149.035 43.346 227.971 48.026 77.836 4.609 162.016-12.204 232.166-62.815 66.29-47.868 113.34-120.934 144.27-194.905 2.59-6.245 5.1-12.491 7.51-18.765 26.02-67.682 42.04-137.374 64.61-205.459 3.86-11.629 7.95-23.259 12.28-34.86 29.34-78.005 71.02-154.503 132.18-210.426 8.78-8.026 17.92-15.55 27.34-22.656 85.87-64.782 203.73-86.075 295.96-48.386 49.86 20.374 88.54 56.656 141 68.242",
    stroke: "#2A2A2A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M213.036 874.789c58.033-88.874 153.052-148.76 248.846-174.029 69.454-18.32 139.524-19.785 207.714-10.381 24.433 3.331 48.579 8.055 72.409 13.511 75.421 17.272 149.092 41.967 227.914 45.944 77.641 3.92 161.331-13.496 231.161-64.078 66.02-47.868 113.13-120.504 144.35-194.115a705.077 705.077 0 0 0 7.59-18.68c26.29-67.337 42.74-136.714 65.7-204.424 3.93-11.573 8.07-23.145 12.48-34.66 29.78-77.574 71.89-153.584 133.31-208.746 8.82-7.925 17.99-15.348 27.45-22.326 86.11-63.72 203.32-83.705 295.66-46.605 49.82 20.015 88.77 55.435 141.17 66.534",
    stroke: "#2C2C2C"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M213.753 879.096c57.574-88.902 151.848-149.377 247.254-175.522 69.109-18.952 139.007-21.192 207.126-12.448 24.418 3.101 48.55 7.581 72.38 12.821 75.421 16.569 149.135 40.589 227.842 43.863 77.455 3.23 160.625-14.788 230.135-65.342 65.74-47.854 112.94-120.087 144.46-193.34a721.745 721.745 0 0 0 7.68-18.579c26.57-66.993 43.44-136.053 66.78-203.405 4-11.515 8.21-23.015 12.67-34.473 30.23-77.158 72.77-152.665 134.44-207.066 8.87-7.825 18.08-15.133 27.56-21.996 86.36-62.657 202.93-81.322 295.36-44.839 49.79 19.656 89.03 54.23 141.35 64.84",
    stroke: "#2E2E2E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M214.485 883.389c57.115-88.945 150.642-149.98 245.661-177.015 68.779-19.57 138.505-22.585 206.552-14.516 24.389 2.857 48.521 7.122 72.351 12.132 75.421 15.866 149.193 39.197 227.785 41.796 77.286 2.541 159.936-16.067 229.136-66.606 65.46-47.854 112.72-119.656 144.54-192.55 2.69-6.145 5.25-12.305 7.75-18.493 26.86-66.648 44.14-135.378 67.87-202.371A982.333 982.333 0 0 1 1429 231.48c30.68-76.742 73.66-151.746 135.57-205.387 8.92-7.724 18.16-14.917 27.67-21.665 86.59-61.595 202.52-78.953 295.05-43.06 49.75 19.298 89.28 53.01 141.5 63.132",
    stroke: "#313131"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.202 887.697c56.656-88.989 149.423-150.583 244.083-178.523 68.435-20.202 138.003-23.978 205.978-16.584 24.375 2.614 48.492 6.662 72.323 11.444 75.421 15.161 149.25 37.818 227.713 39.713 77.101 1.866 159.251-17.359 228.131-67.869 65.18-47.854 112.52-119.226 144.63-191.761 2.7-6.116 5.31-12.247 7.82-18.392 27.13-66.304 44.85-134.718 68.96-201.338 4.14-11.385 8.48-22.771 13.07-34.085 31.14-76.311 74.54-150.827 136.7-203.706 8.97-7.624 18.24-14.703 27.78-21.336 86.82-60.532 202.1-76.584 294.74-41.278 49.71 18.952 89.52 51.802 141.67 61.436",
    stroke: "#333"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.934 891.99c56.197-89.018 148.217-151.186 242.491-180.017 68.09-20.818 137.5-25.384 205.404-18.636 24.361 2.383 48.463 6.188 72.293 10.754 75.422 14.458 149.294 36.44 227.642 37.631 76.916 1.178 158.566-18.636 227.106-69.132 64.91-47.839 112.31-118.795 144.74-190.985a791.66 791.66 0 0 0 7.9-18.292c27.42-65.959 45.55-134.058 70.06-200.318 4.2-11.328 8.6-22.642 13.27-33.899 31.57-75.894 75.42-149.908 137.83-202.026 9.01-7.524 18.32-14.487 27.89-21.006 87.07-59.47 201.7-74.2 294.44-39.498 49.68 18.594 89.77 50.583 141.85 59.728",
    stroke: "#353535"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M216.651 896.297c55.724-89.061 147.013-151.775 240.898-181.51 67.746-21.45 136.984-26.777 204.831-20.703 24.332 2.139 48.435 5.728 72.265 10.064 75.421 13.755 149.35 35.062 227.584 35.564 76.731.488 157.861-19.928 226.111-70.395 64.61-47.84 112.1-118.379 144.81-190.196a688.622 688.622 0 0 0 7.98-18.206c27.7-65.614 46.25-133.383 71.15-199.284a967.481 967.481 0 0 1 13.45-33.712c32.03-75.478 76.31-148.99 138.97-200.333 9.05-7.423 18.4-14.271 28-20.675 87.32-58.407 201.3-71.831 294.14-37.717 49.66 18.234 90.03 49.376 142.01 58.033",
    stroke: "#383838"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M217.383 900.59c55.264-89.089 145.807-152.378 239.306-183.003 67.401-22.068 136.482-28.184 204.242-22.771 24.318 1.895 48.406 5.269 72.236 9.39 75.422 13.051 149.408 33.238 227.513 33.482 76.54.23 157.17-21.206 225.1-71.659 64.33-47.84 111.89-117.948 144.91-189.421 2.76-6.016 5.45-12.06 8.04-18.105 27.98-65.27 46.96-132.722 72.24-198.251 4.33-11.199 8.87-22.397 13.66-33.525 32.47-75.062 77.18-148.07 140.08-198.652 9.1-7.323 18.49-14.07 28.11-20.36 87.56-57.344 200.9-69.448 293.83-35.951 49.62 17.89 90.28 48.17 142.18 56.34",
    stroke: "#3A3A3A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M218.101 904.897c54.805-89.132 144.602-152.981 237.727-184.496 67.072-22.685 135.98-29.577 203.668-24.839 24.289 1.666 48.378 4.796 72.193 8.701 75.422 12.348 149.452 32.291 227.455 31.4 76.356-.875 156.486-22.498 224.086-72.922 64.06-47.826 111.69-117.518 145-188.631a754.92 754.92 0 0 0 8.14-18.019c28.26-64.925 47.66-132.062 73.32-197.231 4.41-11.142 9.01-22.269 13.86-33.324 32.91-74.632 78.08-147.152 141.22-196.973 9.14-7.208 18.56-13.855 28.22-20.029 87.79-56.282 200.48-67.065 293.54-34.171 49.58 17.53 90.51 46.95 142.34 54.63",
    stroke: "#3C3C3C"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M218.832 909.19c54.346-89.175 143.383-153.584 236.135-185.989 66.727-23.317 135.463-30.984 203.094-26.906 24.275 1.421 48.349 4.336 72.165 8.011 75.421 11.644 149.508 30.912 227.383 29.333 76.181-1.551 155.791-23.776 223.081-74.186 63.77-47.825 111.49-117.101 145.09-187.856a776.699 776.699 0 0 0 8.2-17.918c28.55-64.581 48.37-131.402 74.42-196.198a964.248 964.248 0 0 1 14.05-33.137c33.35-74.215 78.96-146.233 142.35-195.293 9.18-7.107 18.65-13.64 28.33-19.699 88.03-55.22 200.08-64.695 293.24-32.39 49.54 17.185 90.77 45.743 142.5 52.936",
    stroke: "#3E3E3E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M219.549 913.497c53.873-89.204 142.178-154.172 234.543-187.482 66.383-23.934 134.961-32.376 202.52-28.974 24.261 1.178 48.32 3.863 72.136 7.323 75.421 10.94 149.566 29.533 227.326 27.251 75.996-2.24 155.106-25.069 222.076-75.45 63.5-47.825 111.27-116.67 145.19-187.066a776.3 776.3 0 0 0 8.28-17.832c28.82-64.236 49.06-130.727 75.5-195.164 4.54-11.027 9.27-22.025 14.25-32.951 33.8-73.798 79.86-145.314 143.48-193.613 9.24-7.007 18.74-13.424 28.44-19.368 88.28-54.158 199.68-62.313 292.93-30.611 49.51 16.827 91.02 44.523 142.68 51.228",
    stroke: "#414141"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M220.281 917.79c53.414-89.247 140.972-154.775 232.95-188.975 66.053-24.552 134.459-33.784 201.947-31.027 24.231.947 48.291 3.403 72.107 6.633 75.421 10.237 149.609 28.155 227.254 25.169 75.811-2.915 154.401-26.361 221.061-76.713 63.21-47.811 111.07-116.24 145.27-186.276a832.224 832.224 0 0 0 8.37-17.732c29.11-63.892 49.75-130.066 76.59-194.144 4.61-10.955 9.4-21.896 14.45-32.75 34.25-73.382 80.73-144.395 144.62-191.933 9.28-6.907 18.81-13.21 28.55-19.039 88.52-53.094 199.26-59.929 292.63-28.83 49.47 16.483 91.26 43.317 142.85 49.534",
    stroke: "#434343"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M220.999 922.098c52.954-89.276 139.767-155.365 231.371-190.469 65.709-25.169 133.957-35.176 201.373-33.095 24.217.704 48.263 2.944 72.078 5.945 75.422 9.533 149.667 26.791 227.197 23.087 75.622-3.604 153.712-27.639 220.052-77.991 62.94-47.811 110.86-115.823 145.36-185.501 2.9-5.858 5.71-11.745 8.44-17.646 29.4-63.547 50.46-129.405 77.69-193.11 4.66-10.898 9.52-21.766 14.65-32.563 34.69-72.952 81.61-143.462 145.73-190.254 9.33-6.805 18.9-12.994 28.67-18.708 88.75-52.032 198.86-57.545 292.33-27.064 49.44 16.124 91.52 42.097 143.01 47.825",
    stroke: "#454545"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M221.73 926.391c52.495-89.319 138.562-155.968 229.779-191.962 65.365-25.787 133.44-36.569 200.785-35.162 24.203.474 48.234 2.469 72.049 5.255 75.408 8.83 149.724 25.413 227.126 21.019 75.431-4.278 153.021-28.93 219.051-79.254 62.65-47.811 110.65-115.393 145.46-184.711 2.93-5.83 5.75-11.688 8.51-17.545 29.67-63.203 51.16-128.746 78.78-192.077a977.304 977.304 0 0 1 14.83-32.377c35.14-72.535 82.51-142.543 146.87-188.573 9.37-6.705 18.98-12.779 28.76-18.378 89-50.97 198.46-55.162 292.03-25.284 49.4 15.779 91.77 40.89 143.19 46.131",
    stroke: "#484848"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M222.448 930.698c52.036-89.362 137.357-156.556 228.187-193.455 65.034-26.404 132.938-37.976 200.21-37.23 24.174.23 48.191 2.01 72.021 4.566 75.407 8.127 149.767 24.035 227.068 18.938 75.266-4.968 152.336-30.209 218.026-80.518 62.38-47.811 110.46-114.962 145.55-183.936a819.87 819.87 0 0 0 8.6-17.459c29.95-62.858 51.86-128.07 79.86-191.057 4.81-10.783 9.8-21.522 15.04-32.176 35.58-72.118 83.4-141.624 148-186.894 9.41-6.604 19.07-12.577 28.88-18.047 89.24-49.907 198.05-52.779 291.72-23.504 49.36 15.42 92 39.67 143.34 44.423",
    stroke: "#4A4A4A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M223.179 934.991c51.563-89.391 136.152-157.159 226.594-194.949 64.69-27.035 132.436-39.368 199.637-39.296 24.16 0 48.162 1.536 71.993 3.89 75.407 7.409 149.824 22.657 226.996 16.856 75.081-5.642 151.631-31.5 217.021-81.781 62.1-47.797 110.24-114.531 145.64-183.146a803.541 803.541 0 0 0 8.66-17.359c30.25-62.513 52.57-127.41 80.98-190.023a936.749 936.749 0 0 1 15.23-31.989c36.03-71.702 84.29-140.691 149.14-185.2 9.47-6.49 19.14-12.362 28.99-17.717 89.49-48.845 197.65-50.395 291.42-21.723 49.32 15.075 92.26 38.464 143.51 42.728",
    stroke: "#4C4C4C"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M223.896 939.298C275 849.864 358.843 781.551 448.913 742.857c64.345-27.639 131.933-40.776 199.062-41.365 24.132-.244 48.134 1.077 71.964 3.202 75.407 6.705 149.882 21.278 226.939 14.788 74.892-6.317 150.942-32.778 216.002-83.044 61.82-47.797 110.04-114.115 145.74-182.371 3-5.743 5.91-11.486 8.74-17.258 30.51-62.169 53.27-126.75 82.06-188.99 4.94-10.654 10.06-21.264 15.42-31.802 36.47-71.272 85.18-139.772 150.27-183.52 9.51-6.39 19.23-12.147 29.1-17.387 89.72-47.782 197.22-47.998 291.11-19.943 49.3 14.73 92.51 37.244 143.68 41.034",
    stroke: "#4F4F4F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M224.628 943.591c50.645-89.477 133.742-158.336 223.424-197.935 64.016-28.256 131.417-42.168 198.489-43.417 24.117-.488 48.105.617 71.935 2.512 75.407 6.002 149.925 19.914 226.867 12.707 74.707-6.992 150.257-34.071 214.997-84.308 61.54-47.797 109.83-113.684 145.83-181.582 3.01-5.7 5.95-11.428 8.82-17.171 30.8-61.825 53.97-126.09 83.15-187.971 5.01-10.596 10.2-21.149 15.63-31.616 36.91-70.855 86.06-138.838 151.39-181.84 9.55-6.288 19.31-11.93 29.21-17.056 89.95-46.72 196.82-45.615 290.81-18.177 49.25 14.386 92.76 36.038 143.84 39.325",
    stroke: "#515151"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M225.346 947.898c50.185-89.505 132.536-158.925 221.831-199.427 63.671-28.874 130.915-43.576 197.9-45.486 24.103-.732 48.077.144 71.907 1.824 75.407 5.298 149.982 18.536 226.809 10.625 74.517-7.667 149.567-35.349 213.997-85.572 61.26-47.782 109.63-113.253 145.92-180.792a843.81 843.81 0 0 0 8.9-17.071c31.09-61.48 54.67-125.414 84.24-186.937 5.07-10.538 10.33-21.02 15.83-31.414 37.36-70.439 86.95-137.906 152.52-180.16 9.6-6.189 19.38-11.716 29.31-16.727 90.2-45.657 196.41-43.231 290.51-16.397 49.22 14.028 93.01 34.818 144.01 37.632",
    stroke: "#535353"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M226.077 952.191c49.726-89.548 131.331-159.513 220.239-200.921 63.341-29.49 130.413-44.968 197.326-47.552 24.075-.962 48.048-.316 71.878 1.134 75.407 4.594 150.04 17.157 226.738 8.543 74.342-8.342 148.882-36.641 212.982-86.835 60.97-47.783 109.41-112.837 146.01-180.017a758.603 758.603 0 0 0 8.96-16.985c31.38-61.135 55.38-124.754 85.34-185.903a930.166 930.166 0 0 1 16.02-31.228c37.82-70.022 87.85-136.986 153.66-178.48 9.64-6.088 19.47-11.5 29.42-16.396 90.45-44.595 196.01-40.834 290.21-14.617 49.18 13.683 93.26 33.612 144.19 35.923",
    stroke: "#565656"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M226.794 956.499c49.253-89.578 130.126-160.103 218.661-202.415 62.997-30.108 129.896-46.361 196.753-49.62 24.059-1.206 48.019-.775 71.849.445 75.407 3.891 150.082 15.794 226.68 6.476a426.285 426.285 0 0 0 211.973-88.099c60.7-47.782 109.21-112.406 146.1-179.227a895.383 895.383 0 0 0 9.05-16.884c31.65-60.791 56.08-124.094 86.42-184.884 5.21-10.409 10.59-20.776 16.22-31.041 38.26-69.592 88.73-136.053 154.78-176.8 9.7-5.973 19.56-11.286 29.54-16.067 90.69-43.532 195.6-38.45 289.91-12.836 49.14 13.339 93.51 32.391 144.35 34.23",
    stroke: "#585858"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M227.526 960.792c48.794-89.621 128.936-160.691 217.068-203.908 62.667-30.725 129.395-47.768 196.179-51.688 24.046-1.45 47.991-1.249 71.806-.244 75.407 3.188 150.14 14.415 226.609 4.394 73.972-9.706 147.482-39.211 210.972-89.362 60.41-47.768 109.01-111.976 146.19-178.452a836.63 836.63 0 0 0 9.13-16.798c31.93-60.446 56.78-123.433 87.51-183.85a914.517 914.517 0 0 1 16.42-30.84c38.7-69.176 89.62-135.12 155.9-175.12 9.75-5.873 19.64-11.085 29.64-15.751 90.92-42.47 195.19-36.052 289.61-11.056 49.11 12.994 93.76 31.185 144.52 32.52",
    stroke: "#5A5A5A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M228.244 965.099c48.334-89.664 127.73-161.28 215.475-205.401 62.323-31.328 128.892-49.161 195.605-53.755 24.017-1.68 47.962-1.709 71.778-.933 75.407 2.484 150.197 13.051 226.551 2.311 73.787-10.38 146.797-40.503 209.947-90.625 60.15-47.768 108.8-111.545 146.29-177.662a845.578 845.578 0 0 0 9.21-16.698c32.22-60.101 57.47-122.758 88.6-182.816 5.34-10.295 10.86-20.517 16.62-30.654 39.15-68.759 90.52-134.2 157.04-173.44 9.78-5.772 19.71-10.869 29.75-15.42 91.16-41.408 194.77-33.655 289.31-9.29 49.06 12.65 94 29.965 144.68 30.826",
    stroke: "#5D5D5D"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M228.975 969.392C276.851 879.7 355.5 807.524 442.858 762.498c61.993-31.946 128.39-50.568 195.017-55.823 24.002-1.924 47.933-2.182 71.749-1.608 75.407 1.781 150.254 11.687 226.479.244 73.617-11.041 146.107-41.781 208.947-91.889 59.86-47.768 108.59-111.128 146.38-176.872a791.916 791.916 0 0 0 9.28-16.612c32.5-59.756 58.18-122.097 89.7-181.796 5.41-10.223 10.99-20.388 16.8-30.467 39.6-68.343 91.42-133.268 158.17-171.761 9.83-5.671 19.8-10.653 29.88-15.09 91.4-40.345 194.35-31.257 289-7.51 49.04 12.305 94.26 28.76 144.84 29.133",
    stroke: "#5F5F5F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M229.693 973.699c47.416-89.735 125.334-162.457 212.305-208.387 61.662-32.563 127.873-51.96 194.443-57.876 23.988-2.168 47.904-2.642 71.72-2.297 75.407 1.077 150.297 10.309 226.422-1.838 73.427-11.716 145.407-43.073 207.947-93.152 59.58-47.754 108.37-110.698 146.46-176.097a794.15 794.15 0 0 0 9.36-16.511c32.78-59.412 58.88-121.438 90.78-180.763 5.47-10.166 11.12-20.273 17.01-30.281 40.04-67.912 92.3-132.334 159.3-170.08 9.87-5.571 19.89-10.439 29.97-14.76 91.65-39.283 193.96-28.86 288.71-5.729 48.99 11.96 94.5 27.538 145.01 27.423",
    stroke: "#616161"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M230.424 977.992c46.943-89.764 124.129-163.046 210.713-209.88 61.318-33.166 127.371-53.368 193.869-59.944 23.959-2.397 47.875-3.101 71.691-2.986 75.407.373 150.384 9.088 226.35-3.92 73.273-12.261 144.713-44.35 206.923-94.416 59.3-47.753 108.18-110.266 146.56-175.307a953.508 953.508 0 0 0 9.44-16.425c33.06-59.067 59.58-120.762 91.87-179.729a924.074 924.074 0 0 1 17.2-30.079c40.49-67.496 93.2-131.402 160.45-168.387 9.92-5.456 19.95-10.223 30.08-14.43 91.88-38.22 193.54-26.46 288.39-3.948 48.95 11.616 94.74 26.332 145.19 25.729",
    stroke: "#646464"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M231.142 982.299c46.483-89.807 122.923-163.619 209.119-211.373 60.989-33.784 126.87-54.76 193.296-62.011 23.945-2.642 47.846-3.575 71.662-3.675 75.407-.331 150.441 7.71 226.293-5.988 73.078-12.936 144.028-45.643 205.918-95.693 59.01-47.754 107.98-109.851 146.66-174.532a877.676 877.676 0 0 0 9.51-16.325c33.34-58.723 60.28-120.102 92.97-178.71a960.482 960.482 0 0 1 17.38-29.892c40.94-67.079 94.09-130.468 161.56-166.707 9.98-5.355 20.05-10.007 30.2-14.1 92.13-37.157 193.14-24.063 288.09-2.167 48.92 11.27 95 25.111 145.35 24.02",
    stroke: "#666"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M231.874 986.592c46.024-89.85 121.819-164.05 207.527-212.866 60.716-34.287 126.367-56.153 192.721-64.079 23.916-2.871 47.818-4.034 71.634-4.364 75.407-1.034 150.484 6.331 226.221-8.069 72.913-13.626 143.343-46.921 204.913-96.958 58.74-47.753 107.76-109.42 146.74-173.742a884.947 884.947 0 0 0 9.59-16.224c33.63-58.378 60.99-119.441 94.05-177.676 5.67-9.979 11.53-19.9 17.59-29.706 41.38-66.663 94.99-129.535 162.7-165.027 10.01-5.255 20.13-9.792 30.3-13.77 92.36-36.094 192.72-21.665 287.78-.401 48.88 10.94 95.25 23.905 145.52 22.326",
    stroke: "#686868"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M232.591 990.9c45.565-89.879 120.614-164.64 205.949-214.36 60.386-34.904 125.851-57.56 192.133-66.146 23.902-3.116 47.789-4.508 71.605-5.054 75.407-1.737 150.542 4.953 226.15-10.151 72.722-14.3 142.652-48.213 203.902-98.221 58.44-47.739 107.55-108.989 146.82-172.966 3.29-5.356 6.51-10.74 9.67-16.138 33.92-58.034 61.69-118.781 95.15-176.657 5.74-9.921 11.65-19.771 17.79-29.505 41.82-66.232 95.94-128.458 163.83-163.347a301.895 301.895 0 0 1 30.41-13.44c92.61-35.032 192.31-19.267 287.48 1.38 48.85 10.595 95.5 22.684 145.7 20.617",
    stroke: "#6A6A6A"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M233.322 995.193c45.107-89.922 119.409-165.243 204.357-215.853 60.042-35.521 125.348-58.953 191.559-68.214 23.888-3.359 47.747-4.968 71.577-5.743 75.407-2.441 150.599 3.575 226.092-12.233 72.538-14.989 141.943-49.505 202.893-99.484 58.18-47.739 107.34-108.558 146.93-172.177 3.31-5.327 6.55-10.682 9.74-16.037 34.19-57.69 62.39-118.107 96.24-175.623 5.81-9.864 11.78-19.642 17.99-29.319 42.26-65.815 96.82-127.539 164.96-161.667a296.34 296.34 0 0 1 30.53-13.109c92.85-33.97 191.86-16.683 287.18 3.16 48.79 10.351 95.75 21.478 145.85 18.922",
    stroke: "#6D6D6D"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M234.04 999.5c44.633-89.951 118.203-165.846 202.764-217.346 59.697-36.153 124.846-60.36 190.985-70.267 23.859-3.589 47.718-5.427 71.548-6.432 75.407-3.144 150.656 2.197 226.02-14.3 72.366-15.665 141.263-50.783 201.893-100.748 57.89-47.739 107.14-108.142 147.01-171.388a877.18 877.18 0 0 0 9.81-15.951c34.48-57.344 63.1-117.446 97.33-174.589a898.974 898.974 0 0 1 18.18-29.132c42.71-65.399 97.71-126.62 166.09-159.987a295.265 295.265 0 0 1 30.63-12.779c93.08-32.907 191.46-14.3 286.88 4.94 48.75 9.992 96 20.258 146.02 17.229",
    stroke: "#6F6F6F"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M234.771 1003.79c44.174-89.991 116.999-166.446 201.172-218.837 59.367-36.77 124.344-61.752 190.412-72.334 23.844-3.833 47.689-5.901 71.519-7.107 75.392-3.848 150.713.819 225.963-16.382 72.179-16.353 140.573-52.075 200.873-102.011 57.61-47.725 106.92-107.711 147.11-170.612a993.869 993.869 0 0 0 9.9-15.851c34.76-57 63.8-116.785 98.42-173.57 5.94-9.734 12.05-19.397 18.38-28.93 43.15-64.983 98.59-125.688 167.21-158.308a292.5 292.5 0 0 1 30.74-12.448c93.33-31.846 191.06-11.917 286.58 6.705 48.73 9.648 96.24 19.053 146.18 15.52",
    stroke: "#717171"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M235.489 1008.1c43.715-90.037 115.808-167.037 199.593-220.333 59.023-37.387 123.828-63.159 189.838-74.401 23.83-4.078 47.66-6.36 71.49-7.796 75.393-4.552 150.757-.56 225.892-18.464 71.992-17.028 139.878-53.353 199.868-103.275 57.33-47.725 106.72-107.28 147.2-169.822a879.405 879.405 0 0 0 9.97-15.765c35.03-56.655 64.5-116.125 99.51-172.536 6.01-9.677 12.18-19.268 18.58-28.744 43.6-64.552 99.48-124.768 168.34-156.628 10.26-4.71 20.53-8.73 30.86-12.118 93.57-30.783 190.66-9.533 286.28 8.486 48.68 9.29 96.5 17.832 146.35 13.826",
    stroke: "#747474"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M236.206 1012.39c43.256-90.063 114.603-167.637 198.001-221.823 58.693-38.019 123.326-64.552 189.264-76.469 23.801-4.307 47.631-6.834 71.462-8.485 75.392-5.255 150.814-1.938 225.833-20.532 71.806-17.717 139.184-54.645 198.864-104.538 57.06-47.725 106.52-106.864 147.28-169.047a870.483 870.483 0 0 0 10.05-15.664c35.32-56.311 65.19-115.45 100.6-171.502a892.013 892.013 0 0 1 18.76-28.558c44.05-64.136 100.37-123.849 169.48-154.948a290.03 290.03 0 0 1 30.96-11.787c93.82-29.72 190.24-7.15 285.98 10.265 48.65 8.945 96.74 16.627 146.52 12.118",
    stroke: "#767676"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M236.938 1016.7c42.797-90.108 113.398-168.243 196.408-223.319 58.349-38.636 122.824-65.945 188.676-78.536 23.787-4.552 47.603-7.294 71.419-9.175 75.392-5.958 150.871-3.316 225.762-22.613 71.634-18.392 138.487-55.923 197.847-105.802 56.77-47.71 106.31-106.433 147.38-168.257a927.909 927.909 0 0 0 10.13-15.578c35.61-55.966 65.9-114.79 101.69-170.483a891.818 891.818 0 0 1 18.97-28.371c44.5-63.719 101.24-122.916 170.61-153.254a285.923 285.923 0 0 1 31.08-11.457c94.04-28.658 189.83-4.767 285.67 12.046 48.62 8.586 96.98 15.406 146.68 10.424",
    stroke: "#787878"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M237.655 1020.99c42.324-90.134 112.193-168.829 194.816-224.809 58.019-39.254 122.307-67.352 188.102-80.604 23.758-4.795 47.574-7.753 71.39-9.864 75.393-6.662 150.929-4.695 225.705-24.695 71.447-19.081 137.802-57.215 196.842-107.065 56.49-47.71 106.11-106.003 147.47-167.468 3.46-5.14 6.86-10.294 10.2-15.477 35.88-55.622 66.6-114.129 102.78-169.45 6.21-9.49 12.58-18.894 19.17-28.169 44.95-63.303 102.13-121.997 171.73-151.574a284.11 284.11 0 0 1 31.19-11.142c94.29-27.595 189.43-2.383 285.37 13.827 48.58 8.241 97.25 14.2 146.86 8.715",
    stroke: "#7B7B7B"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M238.387 1025.3c71.232-153.411 221.314-275.207 380.765-308.962 98.908-20.948 198.762-10.079 297.009-37.316C1061.35 638.763 1184.03 519.71 1269.83 388.61c42.38-64.753 77.84-133.526 123.22-196.399 45.39-62.872 103.03-121.078 172.87-149.894 152.79-63.044 305.05 30.87 463.37 11.817",
    stroke: "#7D7D7D"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 832.225 860.812-.359 860.807.359-860.807.345-860.812-.345Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__b)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 811.191 860.812-.358 860.807.358-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__c)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 790.157 860.812-.344 860.807.344-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__d)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 769.138 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__e)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 748.104 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__f)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 727.084 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__g)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 706.05 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__h)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 685.031 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__i)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 663.997 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__j)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 642.977 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__k)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 621.943 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__l)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 600.923 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__m)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 579.889 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__n)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 558.87 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__o)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 537.836 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__p)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 516.816 860.812-.359 860.807.359-860.807.345-860.812-.345Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__q)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 495.782 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__r)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 474.748 860.812-.344 860.807.344-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__s)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 453.729 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__t)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 432.695 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__u)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 411.675 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__v)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 390.641 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__w)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 369.621 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__x)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 348.587 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__y)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 327.568 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__z)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 306.534 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__A)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 285.514 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__B)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 264.48 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__C)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 243.461 860.812-.359 860.807.359-860.807.358-860.812-.358Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__D)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 222.427 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__E)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 201.407 860.812-.359 860.807.359-860.807.345-860.812-.345Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__F)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 180.373 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__G)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 159.339 860.812-.345 860.807.345-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__H)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 138.319 860.812-.359 860.807.359-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__I)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 117.285 860.812-.358 860.807.358-860.807.359-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__J)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 96.266 860.812-.36 860.807.36-860.807.359-860.812-.36Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__K)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 75.232 860.812-.36 860.807.36-860.807.359-860.812-.36Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__L)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 54.212 860.812-.359 860.807.36-860.807.358-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__M)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 33.178 860.812-.359 860.807.36-860.807.358-860.812-.359Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__N)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-156.809 12.159 860.812-.36 860.807.36-860.807.358-860.812-.358Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__O)",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-93.725-250.07v734.926L71.049 617.521v179.686l111.747 93.985V1098",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__P)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-77.843-257.722v734.925L86.945 609.868v179.686l111.733 93.986v206.81",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__Q)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-61.96-265.375v734.926l164.787 132.65v179.686l111.733 94v206.803",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__R)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-46.065-273.028v734.912L118.71 594.548v179.687l111.733 93.999v206.796",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__S)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-30.183-280.695v734.926L134.59 586.896v179.686l111.733 93.985v206.803",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__T)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M-14.3-288.347v734.925l164.773 132.665v179.686l111.733 93.986v206.805",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__U)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1.581-296v734.926l164.774 132.65v179.686l111.747 94v206.808",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__V)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M17.463-262.977v694.25l164.774 132.651V743.61l111.747 93.999v206.811",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__W)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M33.345-273.028v696.634L198.12 556.271v179.686l111.748 94v206.793",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__X)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M49.227-247.643v663.597l164.788 132.664v179.687l111.733 93.985v206.81",
    stroke: "url(#Discover_Landing_Background_Pattern_Web_svg__Y)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1039.29 16.523c-.26 3.59-3.37 6.303-6.96 6.045-3.59-.259-6.3-3.374-6.04-6.964.26-3.59 3.37-6.303 6.96-6.044 3.59.258 6.28 3.374 6.04 6.963Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__Z)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1127.36 67.005c-.43 5.944-5.58 10.41-11.5 9.979-5.94-.431-10.4-5.586-9.97-11.515.43-5.93 5.58-10.41 11.5-9.979 5.94.43 10.4 5.585 9.97 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__aa)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1039.29 318.58c-.26-3.59-3.37-6.303-6.96-6.045-3.59.259-6.3 3.374-6.04 6.964.26 3.589 3.37 6.303 6.96 6.044 3.59-.258 6.28-3.374 6.04-6.963Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ab)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1127.36 268.084c-.43-5.944-5.58-10.409-11.5-9.979-5.94.431-10.4 5.586-9.97 11.515.43 5.93 5.58 10.41 11.5 9.979 5.94-.431 10.4-5.585 9.97-11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ac)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M141.52 11.814c-.43 5.944-5.581 10.41-11.506 9.979-5.925-.431-10.402-5.585-9.971-11.515.43-5.944 5.581-10.41 11.506-9.979 5.94.431 10.401 5.585 9.971 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ad)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M603.891 651.218a6.872 6.872 0 0 0-7.332-6.36c-3.773.273-6.613 3.546-6.355 7.336a6.87 6.87 0 0 0 7.331 6.361c3.773-.273 6.614-3.546 6.356-7.337Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ae)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M696.543 598.109c-.445-6.245-5.868-10.955-12.109-10.51-6.241.446-10.947 5.873-10.502 12.118.445 6.246 5.868 10.955 12.109 10.51 6.241-.445 10.946-5.872 10.502-12.118Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__af)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1461.92-6.65c-.43 5.944-5.58 10.41-11.51 9.978-5.94-.43-10.4-5.585-9.97-11.514.43-5.93 5.58-10.41 11.51-9.979 5.94.43 10.4 5.585 9.97 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ag)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1373.84 318.58c-.25-3.59-3.37-6.303-6.95-6.045a6.525 6.525 0 0 0-6.04 6.964c.25 3.589 3.37 6.303 6.95 6.044 3.59-.258 6.3-3.374 6.04-6.963Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ah)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1373.84 835.269c-.25-3.589-3.37-6.303-6.95-6.044a6.525 6.525 0 0 0-6.04 6.963c.25 3.589 3.37 6.303 6.95 6.045 3.59-.259 6.3-3.375 6.04-6.964Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ai)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1433.99 413.197c-.44-5.944-5.59-10.409-11.51-9.979-5.94.431-10.4 5.585-9.97 11.515.43 5.93 5.58 10.409 11.5 9.979 5.93-.431 10.41-5.585 9.98-11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__aj)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1322.11 573.041c-.43-5.944-5.58-10.41-11.51-9.979-5.94.431-10.4 5.585-9.97 11.515.43 5.944 5.58 10.409 11.51 9.979 5.92-.431 10.4-5.586 9.97-11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ak)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M987.54 125.713c-.43 5.944-5.581 10.41-11.506 9.979-5.94-.431-10.402-5.585-9.971-11.515.43-5.944 5.581-10.409 11.506-9.979 5.94.431 10.402 5.586 9.971 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__al)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M987.54 209.375c-.43-5.944-5.581-10.409-11.506-9.978-5.94.431-10.402 5.585-9.971 11.515.43 5.944 5.581 10.409 11.506 9.978 5.94-.43 10.402-5.585 9.971-11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__am)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1.696 70.522c-.43 5.944-5.581 10.41-11.506 9.979-5.94-.43-10.402-5.585-9.971-11.515.43-5.944 5.58-10.41 11.506-9.979 5.94.431 10.401 5.586 9.97 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__an)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M549.444 448.33c-.444 6.246-5.867 10.955-12.108 10.51-6.241-.445-10.947-5.872-10.502-12.118.445-6.246 5.868-10.955 12.109-10.51 6.24.445 10.946 5.872 10.501 12.118Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ao)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M549.444 536.343c-.444-6.246-5.867-10.955-12.108-10.51-6.241.445-10.947 5.872-10.502 12.118.445 6.245 5.868 10.955 12.109 10.509 6.24-.445 10.946-5.872 10.501-12.117Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ap)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1447.96 177.229c-.43 5.944-5.58 10.409-11.51 9.978-5.92-.431-10.4-5.585-9.97-11.515.42-5.944 5.58-10.409 11.51-9.978 5.92.431 10.4 5.585 9.97 11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__aq)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    d: "M1322.11 245.427c-.43-5.944-5.58-10.409-11.51-9.978-5.94.431-10.4 5.585-9.97 11.515.43 5.944 5.58 10.409 11.51 9.978 5.94-.43 10.4-5.585 9.97-11.515Z",
    fill: "url(#Discover_Landing_Background_Pattern_Web_svg__ar)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 -241.283 870.054)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 870.055)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 -241.283 735.835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 735.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 735.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 735.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 735.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 735.834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 601.614)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 -241.283 467.395)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 467.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 -241.283 467.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 467.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 467.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 467.394)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__B",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__C",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 333.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__D",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 198.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__E",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 198.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__F",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6710.89 -241.283 198.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__G",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 198.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__H",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.31 -241.283 198.954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__I",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 198.952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__J",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__K",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__L",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__M",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__O",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.71734 0 0 6711.02 -241.283 64.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BABABA",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C7C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__Z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(4.083 292.35 14493.837) scale(6.5135 6.51835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__aa",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(4.083 -369.51 15694.737) scale(10.7745 10.7826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ab",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.49697 -.46378 .46412 6.5018 1032.54 318.956)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ac",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74715 -.76717 .76775 10.75523 1116.37 268.782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ad",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74715 .76717 -.76775 10.75523 130.772 11.004)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ae",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.8404 -.4883 .48866 6.84555 596.801 651.589)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__af",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.30533 -.80702 .80761 11.31371 684.99 598.801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ag",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74725 .76718 -.76774 10.75523 1451.13 -7.536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ah",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.497 -.46378 .46412 6.5018 1367.08 318.969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ai",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(6.497 -.46378 .46412 6.5018 1367.06 835.649)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__aj",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74715 -.76717 .76775 10.75523 1422.97 413.897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ak",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-4.083 8702.99 -18103.157) scale(10.7745 10.7825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__al",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74725 .76718 -.76775 10.75523 976.767 124.854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__am",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74725 -.76718 .76775 10.75523 976.55 210.074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__an",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(4.083 -982.346 -92.037) scale(10.7745 10.7826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ao",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(4.083 -6006.973 7772.004) scale(11.3341 11.3425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ap",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(11.30533 -.80701 .80761 11.31371 537.905 537.027)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__aq",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(10.74725 .76718 -.76774 10.75523 1437.16 176.345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-4.083 4107.9 -18267.192) scale(10.7745 10.7826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__P",
    x1: 44.536,
    y1: -250.07,
    x2: 44.536,
    y2: 1098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__Q",
    x1: 60.417,
    y1: -257.722,
    x2: 60.417,
    y2: 1090.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__R",
    x1: 76.3,
    y1: -265.375,
    x2: 76.3,
    y2: 1082.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__S",
    x1: 92.181,
    y1: -273.028,
    x2: 92.181,
    y2: 1075.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__T",
    x1: 108.078,
    y1: -280.695,
    x2: 108.078,
    y2: 1067.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__U",
    x1: 123.96,
    y1: -288.347,
    x2: 123.96,
    y2: 1059.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__V",
    x1: 139.842,
    y1: -296,
    x2: 139.842,
    y2: 1052.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__W",
    x1: 155.724,
    y1: -262.977,
    x2: 155.724,
    y2: 1044.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__X",
    x1: 171.606,
    y1: -273.028,
    x2: 171.606,
    y2: 1036.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Discover_Landing_Background_Pattern_Web_svg__Y",
    x1: 187.488,
    y1: -247.643,
    x2: 187.488,
    y2: 1029.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Discover_Landing_Background_Pattern_Web_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(-242 -296)",
    d: "M0 0h1971v1394H0z"
  })))));
};
export default SvgDiscoverLandingBackgroundPatternWeb;